// src/i18n/he.ts
// ============================================================================
// Hebrew UI Copy — FULL SSOT (extracted from core.ts)
// Text only — NO logic, NO URLs, NO React
// ============================================================================

export const he = {
  meta: {
    lang: 'he',
    langFull: 'he-IL',
    dir: 'rtl' as const,
    name: 'עברית',
  },

  // ─────────────────────────────────────────────────────────────
  // WORDS
  // ─────────────────────────────────────────────────────────────

  words: {
    dj: {
      he: `דיג׳יי`,
      he_alt: `די ג׳יי`,
      he_plain: `דיגיי`,
      en: `DJ`,
    },
    music: 'מוזיקה',   

    mc: `די ג׳יי`,

    events: {
      wedding: { one: `חתונה`, many: `חתונות`, to: `לחתונה` },
      henna: { one: `חינה`, many: `חינות`, to: `לחינה` },
      bar_bat: { one: `בר/בת מצווה`, many: `בר/בת מצוות`, to: `לבר/בת מצווה` },
      generic: { one: `אירוע`, many: `אירועים`, to: `לאירוע` },
    },

    albums: {
      forum: `פורום`,
      articles: `כתבות`,
      recommendations: `המלצות`,
      bars: `ברים`,
      flyers: `פלאיירים`,
    },

    phrases: {
      music_for_events: `מוזיקה לאירועים`,
      company_or_private: `חברה / פרטי`,
    },
  },

  business: {
    name: 'די ג׳יי אליאור מור - מוזיקה לאירועים',
  
    address: {
      street: 'מבצע יואב 16',
      city: 'באר שבע',
      postal: '8445914',
      country: 'IL',
    },
  },

  // ─────────────────────────────────────────────────────────────
  // BRAND
  // ─────────────────────────────────────────────────────────────

  brand: {
    firstName: `אליאור`,
    short: `אליאור מור`,
    title: `די ג׳יי אליאור מור`,
  },

  metaDescription: {
    wedding:
      'תקליטן מומלץ לחתונה עם מעל 15 שנות ניסיון, התאמה אישית ותכנון מוזיקלי שנבנה לזוג, קריאת קהל חדה ויצירת האווירה המושלמת לכל רגע בחתונה.',
  
    henna:
      'תקליטן מומלץ לחינה עם מעל 15 שנות ניסיון, מוזיקה לכל העדות ושילוב מושלם בין מסורת לקצב עכשווי שהופכת כל חינה לחגיגה שמחה ומיוחדת.',
  
    barBat:
      'תקליטן מומלץ לבר/בת מצווה עם מעל 15 שנות ניסיון, מוזיקה שמותאמת לצעירים ולמבוגרים, קריאת קהל חדה וניהול מוזיקלי מדויק לכל שלב באירוע.',
  
    generic:
      'תקליטן מומלץ לאירועים עם מעל 15 שנות ניסיון, שליטה במגוון רחב של סגנונות מוזיקליים, התאמה מדויקת לקהל ובניית אווירה שמתאימה לכל אירוע.',
  },

  // ─────────────────────────────────────────────────────────────
  // HOME
  // ─────────────────────────────────────────────────────────────

  home: {
    title: `מוזיקה לאירועים | די ג׳יי אליאור מור`,

    description:
      `תקליטן מומלץ לאירועים עם מעל 15 שנות ניסיון, אלפי אירועים ועשור תקליטן הבית של מועדון הפורום, ` +
      `מוזיקה בהתאמה אישית, קריאת קהל חדה ובניית האווירה לכל רגע באירוע.`,

    heroTitle: `אליאור מור - מוזיקה לאירועים`,


    sections: {
      section1Lines: (
        eventOne: string,
        mcLabel: string,
        brandTitle: string
      ) => [
        `מעל 15 שנות ניסיון שמבטיחות ${eventOne} מושלם`,
        'מוזיקה מדויקת וקריאת קהל חדה',
        'סאונד מקצועי ומיקסים מושלמים',
        `${eventOne} עם וייב שמח ואנרגטי`,
        `פלייליסט שמתאים בדיוק ל${eventOne} שלכם`,
        'חוויה מוזיקלית שלא שוכחים',
        'רחבה מלאה מהרגע הראשון ועד השיר האחרון',
      ],
    
      section2DescriptionSuffix: (eventOne: string) =>
        `כדי שכל ${eventOne} יהפוך לחוויה בלתי-נשכחת שהאורחים ידברו עליה עוד הרבה אחרי.`,
    
      section2AdditionalSuffix: '',
    
      section5SubtitleDesktop: (
        weddingOne: string,
        hennaOne: string,
        barBatOne: string,
        genericOne: string
      ) =>
        `בין אם זו ${weddingOne}, ${hennaOne}, ${barBatOne} או כל ${genericOne} אחר – אני מתאים את המוזיקה לאופי הקהל ולאווירה שאתם רוצים ליצור. עם תזמון מדויק, קריאת קהל חדה ושילוב חכם בין סגנונות, הערב זורם בקצב נכון שמרים את האנרגיות ומשאיר את הרחבה מלאה. בזכות שנים של ניסיון מול קהלים מגוונים, אני יוצר רצף מוזיקלי טבעי, מרגש ומחבר – מהצליל הראשון ועד האחרון.`,
    
      section5SubtitleMobile: (
        weddingMany: string,
        hennaMany: string,
        barBatOne: string,
        genericMany: string,
        genericOne: string
      ) =>
        `${weddingMany}, ${hennaMany}, ${barBatOne} ו${genericMany} עסקיים – אני מתאים את המוזיקה לקהל שלכם ומרים רחבה מלאה ושמחה עד סוף ה${genericOne}.`,
    
      section6Title: (brandTitle: string) =>
        `ביקורות והמלצות על ${brandTitle}`,
    
      section6Subtitle: (genericOne: string) =>
        `מה לקוחות מספרים על החוויה איתי ברחבה? ביקורות אמיתיות על המוזיקה, האנרגיה והליווי מהשיחה הראשונה ועד סוף ה${genericOne}.`,
    },
  },
  // ─────────────────────────────────────────────────────────────
  // SECTION 1 — OPEN
  // ────────────────────────────────────────────────────────────

  section1: {  
    targetPageLines: {
      base: [
        'יותר מ־15 שנות ניסיון בכל סוגי האירועים',
        'מוזיקה שנבנית לפי הקצב של הקהל שלכם',
        'קריאת קהל מדויקת ואווירה שעושה חשק לרקוד',
        'רחבה מלאה ושמחה שנמשכת עד השעות הקטנות',
      ],
    
      wedding: [
        'מעל 15 שנות ניסיון בחתונות',
        'מוזיקה מדויקת לכל רגע בחתונה',
        'בניית פסקול אישי שמותאם בדיוק אליכם',
        'מיקסים מושלמים וקריאת קהל חדה',
        'ליווי מקצועי ותכנון מוזיקלי מלא',
        'חתונה שהאורחים לא מפסיקים לדבר עליה',
      ],
    
      henna: [
        'חינה מרגשת עם וייב אותנטי',
        'אווירה צבעונית שמחה וחגיגית',
        'שילוב מושלם של מסורת ומודרניות',
        'מקצבים שמרימים את כל המשפחה',
        'פלייליסט שמתאים בדיוק לחינה שלכם',
        'טקס חינה מרגש עם אווירה מחשמלת',
      ],
    
      bar_bat: [
        'מעל 15 שנות ניסיון בבר/בת מצוות',
        'כניסה מרגשת שהאורחים לא שוכחים',
        'רחבה מלאה מהשיר הראשון עד האחרון',
        'להיטים עדכניים שהנוער והמבוגרים אוהבים',
        'אווירה משפחתית ושמחה',
        'חוויה מוזיקלית שנשארת בזיכרון',
      ],
    
      event: [
        'מעל 15 שנות ניסיון בכל סוגי האירועים',
        'מוזיקה מדויקת וקריאת קהל חדה',
        'סאונד מקצועי ומיקסים מושלמים',
        'אירוע עם וייב שמח ואנרגטי',
        'פלייליסט שמתאים בדיוק לאירוע שלכם',
        'חוויה מוזיקלית שלא שוכחים',
      ],
    },
    hub: {
      city: {
        descriptionLines: (
          keyword: string,
          cityBet: string,
          brandTitle: string
        ) => [
          '15 שנות ניסיון שמדברות מעצמן',
          'מוזיקה שמתאימה לכל סגנון של קהל',
          'יודע להרגיש את הרחבה ולתת את השיר הנכון',
          'אווירה שמחה מתחילת האירוע ועד הסוף',
          `בחירה בטוחה ל${keyword}${cityBet} עם רחבה שלא עוצרת`,
        ],
    
        extraHeadings: (keyword: string, cityBet: string) => [
          `איך לבחור ${keyword}${cityBet} בצורה נכונה`,
          `סוגי אירועים פופולריים${cityBet}`,
        ],
      },
    
      region: {
        descriptionLines: (
          keyword: string,
          regionBet: string,
          brandTitle: string
        ) => [
          'יותר מ־15 שנות ניסיון שמדברות בעד עצמן',
          'מוזיקה מגוונת שמתאימה לכל סוג קהל',
          'רחבת ריקודים שמלאה באנרגיה ושמחה',
          'אווירה חגיגית שנמשכת כל הערב',
          `בחירה בטוחה ל${keyword}${regionBet} עם רחבה שלא עוצרת`,
        ],
    
        extraHeadings: (keyword: string, regionBet: string) => [
          `איך לבחור ${keyword}${regionBet}`,
          `ערים מובילות${regionBet} להתחלת החיפוש`,
        ],
      },
    
      home: {
        section1Lines: (eventOne: string, mcLabel: string, brandTitle: string) => [
          `מעל 15 שנות ניסיון שמבטיחות ${eventOne} מושלם`,
          'מוזיקה מדויקת וקריאת קהל חדה',
          'סאונד מקצועי ומיקסים מושלמים',
          `${eventOne} עם וייב שמח ואנרגטי`,
          `פלייליסט שמתאים בדיוק ל${eventOne} שלכם`,
          'חוויה מוזיקלית שלא שוכחים',
          'רחבה מלאה מהרגע הראשון ועד השיר האחרון',
        ],
      },
    },
  },
  // ─────────────────────────────────────────────────────────────
  // SECTION 2 — ABOUT
  // ─────────────────────────────────────────────────────────────

  section2: {
    title: 'הסיפור שלי',

    description:
      `עם ניסיון של מעל 15 שנים על עמדת הדי ג׳יי, כולל עשור די ג׳יי הבית במועדון הפורום – אני אליאור מור, דיג׳יי שמוביל את הערב בקצב הנכון ויוצר רגעים בלתי נשכחים. בכל אירוע אני מביא אנרגיה מחשמלת, קריאת קהל חדה, מיקסים מדויקים ומוזיקה שמרימה את הרחבה מהשיר הראשון ועד האחרון`,

    additionalText:
      'כל אירוע מבחינתי הוא הזדמנות להרים את הרחבה וליצור רגעים שאנשים זוכרים. המטרה שלי – לוודא שהאורחים נהנים מהאירוע מתחילתו ועד סופו. אני מחבר בין סגנונות, קורא את הקהל ומפתיע עם קטעים שלא שמעתם שנים. וזה מה שהופך את האירוע שלכם לחוויה שמרגישה ברמה אחרת.',

    imageAltPortrait: `אליאור מור על העמדה`,
    imageAltHorizontal: `אליאור מור – די ג׳יי שיודע להרים מסיבה`,

    targetAdditionalByService: {
      wedding:
        'חתונה היא סיפור אהבה שמקבל חיים דרך המוזיקה. חשוב לי קודם כל להכיר אתכם באמת – להבין מי אתם, מה מרגש אתכם ואיך אתם מדמיינים את החתונה שלכם. מתוך ההיכרות הזאת אנחנו בונים יחד פסקול אישי, מדייקים כל רגע ומעצבים יחד את האווירה, כדי להפוך את החלום שלכם למציאות ולחגיגה בלתי נשכחת מהצליל הראשון ועד שיר הסיום.',
    
      henna:
        'כל חינה היא חגיגה צבעונית שאני בונה בקפידה מהרגע הראשון. המטרה שלי פשוטה – אווירה שמחה, קצב שמרים את כולם ורחבה מלאה. אני משלב בין מסורת לקצב עכשווי ויוצר זרימה שלא נותנת לאורחים לשבת.',
    
      bar_bat:
        'כל בר/בת מצווה היא הזדמנות לייצר רגעים מיוחדים שמחברים בין כולם. המטרה שלי פשוטה – ליצור מסיבה שמרגישה טבעית לנוער וגם למבוגרים. עם שילוב נכון של שירים עדכניים וקלאסיקות אהובות, נוצרת חגיגה צעירה וסוחפת שכולם מרגישים חלק ממנה.',
    
      event:
        'כל אירוע הוא הזדמנות ליצור חוויה מוזיקלית מדויקת שמותאמת לקהל ולאופי האירוע. בעזרת קריאת קהל בזמן אמת, מעברים מוזיקליים חלקים ושילוב נכון בין סגנונות, נוצרת אווירה שמרימה את הרחבה ושומרת על אנרגיה גבוהה לאורך כל הערב. כך כל אירוע הופך לחגיגה שהאורחים זוכרים עוד הרבה אחרי שהאירוע מסתיים.',
    },
    
    targetAdditionalSuffixByService: {
      wedding:
        'אני מעניק לחתונה שלכם נגיעה אישית ודיוק שמורגש בכל רגע.',
    
      henna:
        'אני מוסיף לחינה שלכם טאצ׳ מיוחד שהופך אותה לאירוע מלא חיים.',
    
      bar_bat:
        'אני בונה לאירוע שלכם זהות מוזיקלית שמתאימה בדיוק למשפחה ולווייב שאתם רוצים ליצור.',
    
      event:
        'אני מדייק את המוזיקה כך שכל אירוע יקבל את האופי המיוחד שלו.',
    },

    fallbackSuffix:
   'כך האירוע שלכם מקבל וייב שמתאים בדיוק לקהל שלכם.',

    targetDescription: (
      baseDescription: string,
      djKeyword: string,
      cityBet: string
    ) => {
      if (!String(cityBet ?? '').trim()) {
        return `${baseDescription} אני ${djKeyword}, עם ניסיון רחב באירועים, התאמה אישית לקהל ויכולת לקרוא את הרחבה בזמן אמת.`;
      }

      return `${baseDescription} אני ${djKeyword}${cityBet}, עם היכרות מעולה עם הקהל המקומי והאולמות באזור.`;
    },

      targetAdditionalText: (
        base: string,
        cityBet: string,
        suffix: string
      ) => `${base} ${cityBet} ${suffix}`.replace(/\s+/g, ' ').trim(),
  },

  // ─────────────────────────────────────────────────────────────
  // SECTION 3 — GALLERY
  // ─────────────────────────────────────────────────────────────

  section3: {
    title: 'תנו לתמונות לדבר',
    fallbackText: 'בחר אלבום כדי לראות פרטים נוספים',
    albumsError: 'לא ניתן לטעון אלבומים. נסו שוב מאוחר יותר.',
    filesError: 'שגיאה בטעינת הקבצים.',
    loading: 'טוען גלריה…',
    navLabels: {
      video: 'וידאו',
      photos: 'תמונות',
      nextItem: 'תמונה הבאה',
      prevItem: 'תמונה קודמת',
      carousel: 'גלריה',
      currentItem: 'פריט נוכחי',
    },

    galleryHeadings: {
      wedding: (keyword: string, cityBet: string) => [
        `תמונות מ${keyword}${cityBet} – חופה, סלואו ורחבה`,
        `רגעים מחתונות${cityBet} – אנרגיה על הרחבה`,
        `זוגות, רחבה ואנרגיה – רגעים אמיתיים מחתונות${cityBet}`,
      ],
    
      henna: (_keyword: string, cityBet: string) => [
        `גלריית חינה${cityBet} – צבע, מעגלים וקצב`,
        `מסורת ושמחה – חינות${cityBet} בתמונות`,
        `אנרגיה ומשפחה – חינה${cityBet} ברגעים אמיתיים`,
      ],
    
      bar_bat: (_keyword: string, cityBet: string) => [
        `בר/בת מצווה${cityBet} – כניסה, רחבה ואווירה`,
        `נוער ומשפחה רוקדים – בר/בת מצווה${cityBet}`,
        `שיאים ותמונות חיות – בר/בת מצווה${cityBet}`,
      ],
    
      event: (_keyword: string, cityBet: string) => [
        `היילייטס מאירועים${cityBet} – רחבות מלאות`,
        `סטייל מוזיקלי ואנרגיה – אירועים${cityBet}`,
        `גלריית אירועים${cityBet} – רגעים שלא שוכחים`,
      ],
    },

    albumDescriptions: {
      weddings:
        'תמונות מתוך חתונות אמיתיות – חופה, סלואו ורחבה בוערת. וייב שמרים את כל האורחים מהרגע הראשון ועד האחרון.',

      hennas:
        'צבע, תופים ומעגלים – חינות מלאות אנרגיה ושמחה עם שילוב מושלם בין מסורת לוייב עכשווי.',

      barBat:
        'רגעים מבר/בת מצוות – כניסת מצווה, רחבת נוער ומשפחה, ואווירה מחשמלת שמחברת את כולם.',

      forum:
        'סטים מחשמלים ממועדון הפורום באר שבע, שם שימשתי כרזידנט עשור. אווירה של 3,000 חוגגים בכל סוף שבוע.',

      articles:
        'אוסף כתבות, ראיונות וסיקורים תקשורתיים – הסיפורים והאירועים שמאחורי המוזיקה.',

      recommendations:
        'טסטימוניאלס אמיתיים מלקוחות – פידבקים, הודעות ומכתבי תודה אחרי לילות בלתי נשכחים.',

      bars:
        'סטים מברים ומקומות בילוי ברחבי הארץ – מוזיקה מדויקת לקהל וערבים מלאי אנרגיה.',

      flyers:
        'אוסף הפלאיירים מערבי מועדונים ואירועים – כל אחד מספר סיפור של לילה חם במיוחד.',
    },

    albumTexts: {
      weddings:
        'מעבר למוזיקה עצמה, חשוב לי ללוות אתכם לחתונה לאורך כל הדרך. אני מביא איתי ניסיון של מאות זוגות מרוצים, ראייה רחבה של החתונה ותשומת לב לפרטים הקטנים שעושים את ההבדל. המטרה שלי היא לתת לכם שקט נפשי, ביטחון מקצועי וידיעה שיש מי שמוביל את החתונה בצורה מדויקת.',

      forum:
        'פורום באר שבע – מועדון ברמה בינלאומית שבו שימשתי כרזידנט במשך 10 שנים, עם סטים מחשמלים מול 3,000 חוגגים בכל סוף שבוע. מוזיקה עדכנית, אפקטים עוצמתיים ואווירה שאין כמוה בישראל',

      articles:
        'אוסף כתבות שהתפרסמו עליי במדיה הארצית והמקומית, הכוללות ראיונות, סיפורים ותיעוד אירועים מיוחדים בהם השתתפתי, ומשקפות את הדרך והעשייה המוזיקלית שלי לאורך השנים',

      hennas:
        'חינות הן השילוב המושלם בין מסורת, צבע ושמחה מתפרצת. עם מוזיקה אותנטית, תופים מרעידים ואנרגיות שמרימות את האולם, אני יוצר חוויית חינה עוצמתית ובלתי נשכחת. ניסיון של שנים בהובלת אירועי חינה מבטיח שכל האורחים, צעירים ומבוגרים, יישארו על הרגליים וירקדו עד הרגע האחרון',

      recommendations:
        'דברי תודה והמלצות מלקוחות שחוו איתי אירועים מרגשים ומלאי אנרגיה. כל מכתב וכל הודעה הם עדות לאהבה ולחוויות שיצרנו יחד',

      barBat:
        'בר/בת מצווה הוא אירוע של פעם בחיים – ואני כאן כדי להפוך אותו לחגיגה אמיתית. שילוב מנצח של מוזיקה עדכנית עם להיטים על-זמניים, הפעלות מגניבות ואווירה מחשמלת. עם ניסיון עשיר בניהול אירועי בר/בת מצווה, אני מבטיח שכל האורחים, מהחבר׳ה של החוגג/ת ועד הסבא והסבתא, ייהנו מרגעים שייזכרו לנצח',

      bars:
        'במהלך הקריירה ניגנתי במגוון ברים ומקומות בילוי בכל רחבי הארץ. לכל מקום הבאתי את הסאונד והווייב הייחודי שלי, עם מוזיקה שמתאימה בדיוק לקהל ומייצרת אווירה מושלמת לבילוי',

      flyers:
        'אוסף הפלאיירים של המקומות בהם הופעתי – מהפורום בבאר שבע ועד ברים ואולמות בכל הארץ. כל פלאייר מספר את סיפורו של ערב מלא במוזיקה, אנשים ואנרגיות שבלתי אפשר לשכוח',
    },
  },

  // ─────────────────────────────────────────────────────────────
  // SECTION 4 — CONTACT / CTA
  // ─────────────────────────────────────────────────────────────

  section4: {
    title: 'שדרג את האירוע שלך',

    description:
      'מחפשים די ג׳יי לאירוע שלכם?\nכאן תמצאו את השילוב המנצח של ניסיון, אנרגיה ומוזיקה',

    groupTitles: {
      contact: 'יצירת קשר',
      events: 'קטגוריות אירועים',
      services: 'שירותים נוספים',
    },

    eventsIntro: {
      default: `מוזיקה מותאמת לכל סגנון אירוע, פרטי או עסקי.`,
  
      wedding: (keyword: string, cityBet: string) =>
        `${keyword}${cityBet} – מהחופה ועד המסיבה, מוזיקה שמדויקת לכם ולאורחים.`,
  
      henna: (keyword: string, cityBet: string) =>
        `${keyword}${cityBet} – שילוב של מקצבים מסורתיים וביטים עכשוויים, חגיגה צבעונית לכל המשפחה.`,
  
      bar_bat: (keyword: string, cityBet: string) =>
        `${keyword}${cityBet} – להיטים עדכניים לצד קלאסיקות שכל הדורות נהנים מהם.`,
  
      event: (keyword: string, cityBet: string) =>
        `${keyword}${cityBet} – מוזיקה מותאמת לכל סגנון אירוע, פרטי או עסקי.`,
    },

    servicesIntro: {
      wedding: (_keyword: string, cityBet: string) =>
        `אפשר לשלב גם תאורה, הגברה, אטרקציות ונגנים לפי אופי החתונה${cityBet}.`,
    
      henna: (_keyword: string, cityBet: string) =>
        `אפשר לשלב גם תאורה, הגברה, אטרקציות ונגנים לפי אופי החינה${cityBet}.`,
    
      bar_bat: (_keyword: string, cityBet: string) =>
        `אפשר לשלב גם תאורה, הגברה, אטרקציות ונגנים לפי אופי בר/בת המצווה${cityBet}.`,
    
      event: (_keyword: string, cityBet: string) =>
        `אפשר לשלב גם תאורה, הגברה, אטרקציות ונגנים לפי אופי האירוע${cityBet}.`,
    },

    blockCopy: {
      withCity: (
        keyword: string,
        cityName: string,
        firstName: string
      ) => ({
        description:
          `מחפשים ${keyword} ב${cityName}?\nכאן תמצאו את השילוב המנצח של ניסיון, אנרגיה ומוזיקה.`,
    
        whatsappPrefill:
          `שלום ${firstName}, מעוניין/ת ב${keyword} ב${cityName}`,
    
        linksHeading:
          `עמודים קשורים ל${keyword} ב${cityName}`,
      }),
    
      withoutCity: (
        keyword: string,
        eventName: string,
        firstName: string
      ) => ({
        description:
          `מחפשים ${keyword} ${keyword === 'די ג׳יי' || keyword === 'דיג׳יי' ? `ל${eventName} שלכם` : 'שלכם'}?\nכאן תמצאו את השילוב המנצח של ניסיון, אנרגיה ומוזיקה.`,
    
        whatsappPrefill:
          `שלום ${firstName}, מעוניין/ת ב${keyword} ל${eventName} שלי`,
    
        linksHeading:
          `עמודים קשורים ל${keyword}`,
      }),
    },
  
    contactSeo: {
      phone: `דברו איתי בטלפון – אשמח לענות על כל שאלה.`,
      whatsapp: `כתבו לי בוואטסאפ ותוך רגעים אחזור עם פרטים.`,
      email: `אפשר גם במייל – שלחו הודעה ואחזור אליכם בהקדם.`,
      instagram: `תציצו באינסטגרם – סרטונים ותמונות חיות מהרחבה.`,
      facebook: `בפייסבוק תמצאו המלצות וקטעים מאירועים אמיתיים.`,
      navigate: `קל להגיע – לחצו לנווט אליי ב-Google Maps.`,
    },

    contactButtons: {
      phone: 'שיחה',
      whatsapp: 'וואטסאפ',
      email: 'אימייל',
      instagram: 'אינסטגרם',
      facebook: 'פייסבוק',
      navigate: 'נווט אליי',
    },

 
      services: {
        sound: {
          label: 'הגברה',
          description: 'הגברה מקצועית – סאונד נקי וברור בכל חלל.',
        },
        light: {
          label: 'תאורה',
          description: 'תאורה דינמית – הופכת כל רחבה למשהו מיוחד.',
        },
        attractions: {
          label: 'אטרקציות',
          description: 'אטרקציות לאירוע – קונפטי, עשן כבד, בלונים ועוד.',
        },
        recording: {
          label: 'נגנים',
          description: 'שילוב נגנים חיים ברגעים נכונים באירוע.',
        },
      },

      eventsTexts: {
        wedding: (cityBet: string) =>
          `די ג׳יי לחתונה${cityBet} – מוזיקה שמתאימה בדיוק לזוג ולאורחים.`,
      
        henna: (cityBet: string) =>
          `די ג׳יי לחינה${cityBet} – שילוב מושלם של אותנטיות וביטים עדכניים.`,
      
        bar_bat: (cityBet: string) =>
          `די ג׳יי לבר/בת מצווה${cityBet} – להיטים לכל הדורות.`,
      
        event: (cityBet: string) =>
          `די ג׳יי לאירוע${cityBet} – חברה / פרטי, מותאם לכל סגנון.`,
      },

      groupTitlesSeo: {
        wedding: (keyword: string, cityBet: string, brand: string) => ({
          contact: `יצירת קשר עם ${brand}`,
          events: `קטגוריות אירועים נוספות${cityBet}`,
          services: `שירותים משלימים לחתונה${cityBet}`,
          links: `עמודים קשורים ל${keyword}${cityBet}`,
        }),
      
        henna: (keyword: string, cityBet: string, brand: string) => ({
          contact: `יצירת קשר עם ${brand}`,
          events: `עוד סוגי אירועים שאני מרים${cityBet}`,
          services: `שירותים משלימים לחינה${cityBet}`,
          links: `עמודים קשורים ל${keyword}${cityBet}`,
        }),
      
        bar_bat: (keyword: string, cityBet: string, brand: string) => ({
          contact: `יצירת קשר עם ${brand}`,
          events: `קטגוריות אירועים פופולריות${cityBet}`,
          services: `שירותים משלימים לבר/בת מצווה${cityBet}`,
          links: `עמודים קשורים ל${keyword}${cityBet}`,
        }),
      
        event: (keyword: string, cityBet: string, brand: string) => ({
          contact: `יצירת קשר עם ${brand}`,
          events: `קטגוריות אירועים שאני מכסה${cityBet}`,
          services: `שירותים משלימים לאירועים${cityBet}`,
          links: `עמודים קשורים ל${keyword}${cityBet}`,
        }),
      },

    prefills: {
      wedding:
        'היי אליאור,\nאשמח לשמוע פרטים לגבי די ג׳יי לחתונה.',
      henna:
        'שלום אליאור,\nאני מתעניין בדי ג׳יי לחינה.',
      barBat:
        'היי,\nמחפש די ג׳יי לבר/בת מצווה – אפשר פרטים?',
      generic:
        'שלום,\nאני מחפש די ג׳יי לאירוע חברה / פרטי.',
    },
  },

  // ─────────────────────────────────────────────────────────────
  // SECTION 5 — FAQ
  // ─────────────────────────────────────────────────────────────

  section5: {
    title: 'מידע נוסף ושאלות נפוצות',
    linksHeading: 'עמודים קשורים שכדאי לבדוק',
    headingsSeo: {
      wedding: (keyword: string, cityBet: string) => [
        `תכנון מוזיקלי לחתונה${cityBet} מהשיחה הראשונה ועד`,
        `השיר האחרון, לפי הסגנון שלכם והקהל שמגיע לחגוג אתכם.`,
        `קבלת פנים אלגנטית עם מוזיקה נכונה שמכניסה`,
        `את האורחים לאווירה טובה ומשאירה מקום לשיחות ולמפגש.`,
        `ליווי מלא לחופה עם בחירת שירים מדויקת`,
        `לכניסת החתן, הכלה ורגע שבירת הכוס.`,
        `מעבר מתוכנן מהחופה לריקודי הפתיחה כך`,
        `שהאירוע ממשיך באופן טבעי והאורחים מצטרפים לרחבה.`,
        `קטע סלואו מרגש שמבוסס על מי שאתם`,
        `כזוג ויוצר רגע אישי שלא שוכחים.`,
        `שילוב של שירים וסגנונות שמתאימים לכל`,
        `שלב בערב, כדי שהרחבה תישאר מלאה והאורחים ייהנו מכל רגע.`,
        `${keyword}${cityBet} שמלווה אתכם עד סוף הערב`,
        `עם מוזיקה שמחזיקה את האנרגיה גבוהה וחיוך אצל כולם.`,
      ],
    
      henna: (keyword: string, cityBet: string) => [
        `תכנון חינה${cityBet} לפי המסורת של המשפחה`,
        `והאווירה שאתם רוצים ליצור, עם מוזיקה שמתאימה לחינה שמחה וצבעונית.`,
        `כניסה חגיגית עם שיר שמתאים לעדה ולמשפחה`,
        `ופותחת את הערב באנרגיה טובה ונכונה.`,
        `שירי חינה, מוזיקה עדתית ומעגלים משפחתיים`,
        `שמתאימים לעדות השונות, כדי שכל אחד ירגיש חלק מהחגיגה.`,
        `החלפת תלבושות ורגעי כניסה שמתואמים מראש`,
        `כדי שהמעבר לטקס ולריקודים ירגיש טבעי.`,
        `טקס החינה בליווי מוזיקה שמתאימה למריחת`,
        `החינה, לטקס הענקת הזהב ולמעגלים של המשפחה.`,
        `זמן לצילומים ומתנות עם מוזיקה`,
        `נעימה שמתאימה לרגעים האישיים.`,
        `${keyword}${cityBet} שמביא את השילוב הנכון בין`,
        `מסורת, שמחה ומוזיקה שאנשים אוהבים.`,
      ],
    
      bar_bat: (keyword: string, cityBet: string) => [
        `תכנון בר/בת מצווה${cityBet} עם מוזיקה שמדברת גם`,
        `לנוער וגם למבוגרים, כדי שכל אחד ירגיש חלק מהחגיגה.`,
        `קבלת פנים עם מוזיקה קלילה ונעימה שמכינה`,
        `את האורחים לערב ומאפשרת מפגשים וצילומים.`,
        `כניסת מצווה מתואמת מראש עם שיר שבוחרים יחד,`,
        `הכרזה ורגע כניסה שהחוגג או החוגגת מרגישים בו במרכז הבמה.`,
        `ליווי דרשה, סרטון או מצגת עם מוזיקה`,
        `שמוסיפה רגש ומדגישה את חשיבות הרגע.`,
        `סטים קצביים עם שירים עדכניים לנוער בשילוב מוזיקה`,
        `שמתאימה גם למבוגרים, כך שהרחבה נשארת מלאה מכל הגילים.`,
        `אפשרות לקטע ריקוד מיוחד או שי שהחוגג בוחר`,
        `ולרגע בו הוא עולה לעמדה ומרגיש חלק פעיל מהאירוע.`,
        `חלוקה של זוהרים ואביזרים לרחבה שיוצרים`,
        `אנרגיה צעירה ומעלים את רמת ההתלהבות של כולם.`,
        `${keyword}${cityBet} שמוביל את הערב כך`,
        `שהנוער נהנה מהמוזיקה שלהם והמבוגרים מרגישים חלק מהשמחה.`,
      ],
    
      event: (
        keyword: string,
        cityBet: string,
        hasCity: boolean
      ) => {
        if (!hasCity) {
          return [
            `הכול מתחיל בשיחה מקדימה כדי להבין אתכם,`,
            `את הקהל שלכם ואת סוג האירוע שאתם מתכננים.`,
            `לאחר מכן אני בונה תכנית מוזיקלית שמתאימה`,
            `לקבלת הפנים, לרגעים רשמיים ולשיאים של הערב.`,
            `ברגעים המיוחדים כמו טקסים משפחתיים או`,
            `רגעי הוקרה, המוזיקה מדגישה את הרגש ומקרבת בין האנשים.`,
            `בשלב הריקודים הקצב מותאם לקהל כדי`,
            `לשמור על אנרגיה טובה על הרחבה.`,
            `המעברים בין השירים נקיים ומתוכננים כך`,
            `שהאורחים מרגישים שהמוזיקה מתפתחת בצורה טבעית.`,
            `הסאונד מותאם לאולם ולכמות האורחים כדי`,
            `שהמוזיקה תשמע טוב בכל חלק באירוע.`,
            `${keyword} שיוצר ערב חם, מקצועי ובלתי־נשכח`,
            `שהאורחים זוכרים גם אחרי שהוא מסתיים.`,
          ];
        }
    
        return [
          `תכנון אירוע${cityBet} עם ${keyword} שמותאם לאופי`,
          `שלכם, לסוג הקהל ולמקום שבו חוגגים.`,
          `כבר בשלב קבלת הפנים המוזיקה מותאמת`,
          `למפגש בין האורחים ויוצרת אווירה נעימה להתחלה.`,
          `לרגעים רשמיים כמו ברכות, מצגת קצרה או`,
          `טקס משפחתי נבחרת מוזיקה שמדגישה את המשמעות של הרגע.`,
          `בהמשך הערב אני מעלה בהדרגה את הקצב`,
          `ומעביר את המיקוד לרחבת הריקודים בצורה טבעית.`,
          `במהלך הערב אני קורא את הקהל ומחליט מתי`,
          `לשלב סגנונות שונים כדי להשאיר את הרחבה פעילה.`,
          `הסאונד מותאם לגודל האולם ולקהל באירוע${cityBet} כדי`,
          `שכל מי שנמצא במקום ייהנה מהמוזיקה.`,
          `${keyword}${cityBet} שמלווה אתכם לכל אורך הערב`,
          `וגורם לאורחים לצאת מרוצים מהחוויה שעברו.`,
        ];
      },
    },
    eventTypeDescription: {
      wedding: {
        mobile: (city: string, cityBet: string) =>
          `המוזיקה בחתונה שלכם${cityBet} נבנית סביב הסיפור והאווירה שאתם רוצים ליצור – מקבלת פנים נעימה, דרך החופה והרגעים המרגשים, ועד מסיבה מלאה באנרגיה שמחברת בין כל האורחים.`,
    
        desktop: (city: string, cityBet: string) =>
          `כדי להפוך את החתונה שלכם${cityBet} לחוויה בלתי נשכחת, אני יוצר עבורכם פסקול אישי שמותאם לכל שלב באירוע – מקבלת פנים אלגנטית ונעימה, דרך החופה והרגעים המרגשים, ועד מסיבה מלאה באנרגיה שמחברת בין כל האורחים. בעזרת קריאת קהל מדויקת, מעברים מוזיקליים חלקים ושילוב נכון בין סגנונות מוזיקליים, נבנית חוויה מוזיקלית שמובילה את האירוע לחגיגה אמיתית.`,
      },
    
      event: {
        mobile: (_city: string, cityBet: string) =>
          `בכל אירוע ${cityBet} אני מתאים את הסטייל המוזיקלי לאופי הקהל. המעברים חלקים, הפלייליסט מגוון והאנרגיה בונה אווירה מחשמלת שגורמת לכולם לרקוד.`,
    
        desktop: (_city: string, cityBet: string) =>
          `בכל אירוע ${cityBet} אני מתאים את הסאונד ואת סגנון המוזיקה לאופי הקהל ולמהות האירוע. עם שילוב נכון של להיטים, קלאסיקות, קצב מדויק ומעברים מקצועיים, אני יוצר אווירה עם חיבור מדויק לקהל – הערב רץ בקצב גבוה ומשאיר את כולם בתוך החוויה עד השיר האחרון.`,
      },
    
      bar_bat: {
        mobile: (_city: string, cityBet: string) =>
          `בר/בת מצווה ${cityBet} זו חגיגה של פעם בחיים. אני משלב להיטים עדכניים לנוער עם קלאסיקות שכל המשפחה אוהבת, יוצר רגעים של שיא ואווירה שכולם זוכרים.`,
    
        desktop: (_city: string, cityBet: string) =>
          `בר/בת מצווה ${cityBet} היא חגיגה של פעם בחיים, ואני יוצר שילוב מדויק בין מוזיקה עדכנית שהנוער אוהב לבין שירי מסיבה ועל־זמניים שכל המשפחה מתחברת אליהם. עם קצב נכון, רגעי שיא מרגשים ורחבה שמתמלאת באנרגיה, אני דואג שהאירוע יהיה שמח, צעיר ומלא זיכרונות טובים.`,
      },
    
      henna: {
        mobile: (_city: string, cityBet: string) =>
          `חינה${cityBet} היא מסורת צבעונית ושמחה. אני משלב מוזיקה אותנטית, קצב מודרני ומעגלים – כדי להפוך את החינה שלכם למסיבה מלאה באנרגיה.`,
    
        desktop: (_city: string, cityBet: string) =>
          `חינה${cityBet} היא מסיבה צבעונית ומלאת מסורת, ואני מקפיד לשלב בין מוזיקה אותנטית שמחברת לשורשים לבין קצב מודרני שמרים את הרחבה. מעגלים, מקצבים מזרחיים וסט עכשווי שמתאים לכל הגילאים – הכל כדי ליצור חוויה שמחה, חמה ומשפחתית שתשאיר את כולם עם חיוך גדול.`,
      },
    },
  },
  // ─────────────────────────────────────────────────────────────
  // SECTION 5 — RECOMENDS
  // ─────────────────────────────────────────────────────────────

  section6: {
    defaults: {
      title: (brandTitle: string) =>
        `ביקורות והמלצות על ${brandTitle}`,
    
      subtitle: (
        brandShort: string,
        keyword: string,
        cityBet: string
      ) =>
        `מה לקוחות מספרים על ${brandShort}?\nהמלצות על ${keyword}${cityBet} – חוות דעת אמיתיות על אנרגיה ברחבה, קריאת קהל ושירות מקצועי.`,
    },
    reviewsCount: (count: number) =>
      `מבוסס על ${count} ביקורות`,
  
  },

  // ─────────────────────────────────────────────────────────────
  // FOOTER
  // ─────────────────────────────────────────────────────────────

  footer: {
    copyright: (year: number) =>
      `© ${year} די ג׳יי אליאור מור – כל הזכויות שמורות`,
    recommendedPages: 'עוד עמודים מומלצים',
    addressLabel: 'כתובת',
    addresses: {
      south: 'מבצע יואב 16, באר שבע',
      center: 'מגדלי אלון 2, תל אביב',
    },
    accessibilityStatement: 'הצהרת נגישות',
  },

  // ─────────────────────────────────────────────────────────────
  // MISC
  // ─────────────────────────────────────────────────────────────

  misc: {
    professional: 'מקצועי',
    recommended: 'מומלץ',
  },

  planning: {
    readMoreLabel: 'למדריך המלא',
    previousLabel: 'הקודם',
    nextLabel: 'הבא',
    backHomeLabel: 'חזרה',
    articleEyebrow: (service: string) => `${service} - מדריך תכנון`,
    contactTitle: 'רוצים לתכנן את המוזיקה נכון?',
    contactButtonLabel: 'דברו איתי',
    whatsappLabel: 'וואטסאפ',
    phoneLabel: 'שיחה טלפונית',
    parentLinkLabel: (serviceLabel: string) => `עמוד ${serviceLabel}`,
    parentContext: (articleTitle: string, serviceLabel: string) => ({
      before: `אחרי שקוראים על ${articleTitle}, בעמוד`,
      linkLabel: serviceLabel,
      after: 'אפשר לראות איך מחברים את הנושא לבחירת השירים, הלו״ז, הסאונד, האטרקציות ורחבת הריקודים.',
    }),
    whatsappText: (articleTitle: string) =>
      `שלום אליאור, קראתי באתר את המדריך "${articleTitle}" ואשמח להתייעץ על תכנון מוזיקלי לאירוע שלי.`,
    trustTitle: 'איך זה עובד בפועל באירוע',
    trustParagraphs: (articleTitle: string, serviceLabel: string, brandShort: string) => [
      `${articleTitle} הוא לא רק רעיון יפה לרשימה. באירוע אמיתי הוא צריך להתאים לקהל, למקום, למשפחה, לשעה ביום ולרצף המוזיקלי של הערב. כשאני מתכנן ${serviceLabel}, אני מסתכל על כל התמונה ולא רק על שיר אחד או אטרקציה אחת.`,
      `הניסיון שלי כ${brandShort} עוזר להבין איפה כדאי לתת לרגש מקום, איפה צריך להרים קצב, ואיפה דווקא שקט או מעבר קצר עושים עבודה טובה יותר. תכנון נכון מונע עצירות מיותרות ומאפשר לאורחים להרגיש שהערב זורם טבעי.`,
      `לפני האירוע אני אוהב להבין מי הקהל, אילו סגנונות חשובים לכם, מה לא תרצו לשמוע, ואילו רגעים חייבים להיות מדויקים. ככה אפשר לבנות תכנית מוזיקלית אמינה, אישית ומקצועית יותר.`,
      `אם משלבים אטרקציות, חשוב שהן יעבדו עם המוזיקה ולא נגדה: זיקוקים קרים לכניסה, תותחי עשן, בלונים מתפוצצים לסלואו, אותיות חתן וכלה, לייזרים, מתנפחים מעוצבים, וידאו AI או אפטר פארטי ברחבה צריכים להיכנס בנקודת זמן נכונה, עם תיאום מול האולם ועם סאונד שמתאים לרגע.`,
    ],
    workTitle: 'צ׳ק ליסט קצר לפני האירוע',
    workBullets: [
      'סדר האירוע והמעברים בין קבלת פנים, טקס, אוכל ורחבה.',
      'שירים שחייבים להיות, שירים שלא מתאימים לכם וסגנונות מועדפים.',
      'התאמה לקהל: משפחה, חברים, צעירים, מבוגרים או קהל עסקי.',
      'תיאום מול האולם, ספקים, נגנים, אטרקציות וציוד סאונד.',
      'בדיקה שהאטרקציות לא מסתירות צילום, לא חוסמות רחבה ולא מתנגשות עם שיא מוזיקלי אחר.',
      'תכנון רגעי אפטר פארטי, ירידה של הדיג׳יי לרחבה, החלפת סגנון מוזיקלי והרמת קצב לקהל שנשאר עד מאוחר.',
    ],
    carouselLabel: (title: string) => `${title} - מדריכים`,
    guideTitle: 'מדריך אירועים',
    guideSubtitle: 'כל המדריכים לתכנון חתונה, חינה, בר/בת מצווה ואירוע פרטי או עסקי במקום אחד: מוזיקה, לו״ז, כניסות, אטרקציות ונגנים.',
    relatedTitle: 'עוד מדריכים שיכולים לעזור',
    faqTitle: 'שאלות נפוצות',
    authorTitle: 'נכתב מניסיון בשטח',
    authorText: 'המאמר נכתב על בסיס ניסיון של מעל 15 שנים באירועים, חתונות, חינות ובר/בת מצווה. המטרה היא לתת לכם מידע מעשי שאפשר להשתמש בו באמת בתכנון האירוע, ולא רק רשימת רעיונות כללית.',
    cityVenueGuide: {
      moreLabel: 'ועוד',
      groupTitle: 'בחירת אולמות לפי עיר',
      groupSubtitle: 'כל מדריכי בחירת האולם לפי עיר: רשימת אולמות, נקודות בדיקה, התאמה לקהל, לסאונד, ללוח הזמנים ולסגנון האירוע.',
      title: (_cityLabel: string, cityBet: string) => `בחירת אולם${cityBet}`,
      sectionTitle: (_cityLabel: string, cityBet: string) => `איך לבחור אולם${cityBet} לפי האופי של האירוע`,
      description: (_cityLabel: string, cityBet: string) =>
        `מדריך לבחירת אולם${cityBet}: איך להשוות בין אולמות, מה לבדוק בסיור, ואיך לחבר את המקום למוזיקה, לסאונד וללו״ז של האירוע.`,
      intro: (cityLabel: string, _cityBet: string, venuesCount: number, venuePreview: string) =>
        `בעיר ${cityLabel} קיימים ${venuesCount} מקומות שכדאי להכיר לפני שסוגרים אירוע, כולל ${venuePreview}. המטרה היא לא לבחור רק מקום יפה בתמונות, אלא אולם שמתאים לקהל, ללו״ז, למוזיקה ולדרך שבה אתם רוצים שהאירוע ירגיש.`,
      overviewBullets: (_cityLabel: string, cityBet: string) => [
        'להתחיל מהאופי של האירוע: חתונה עם רחבה גדולה, חינה משפחתית, בר/בת מצווה עם כניסה וטקס, אירוע עסקי מסודר או אירוע בוטיק אינטימי.',
        `לסנן לפי כמות אורחים, תקציב ונוחות הגעה${cityBet}, ואז לבדוק אם המקום באמת מתאים לזרימה של הערב ולא רק נראה טוב בתמונות.`,
        'בסיור במקום כדאי להשוות תמיד את אותם פרמטרים: חניה, נגישות, קבלת פנים, גודל רחבה, אקוסטיקה, גובה תקרה, תאורה, שירות ומיקום עמדת הדי ג׳יי.',
        'לפני חתימה חשוב לבקש מפרט טכני, להבין מגבלות סאונד ושעות פעילות, ולוודא שיש איש קשר ברור לתיאום ספקים ביום האירוע.',
      ],
      venueListBullet: (_cityLabel: string, cityBet: string, venues: readonly string[]) =>
        `רשימת האולמות${cityBet}: ${venues.join(', ')}.`,
      cta: (_cityLabel: string, cityBet: string) =>
        `סגרתם או בודקים אולם${cityBet}? אפשר לבנות יחד תכנית מוזיקלית שמתאימה למקום, לקהל ולרגעים החשובים של הערב.`,
      parentServiceLabel: (serviceLabel: string, _cityLabel: string, cityBet: string) =>
        `${serviceLabel}${cityBet}`,
      trustTitle: (_cityLabel: string, cityBet: string) => `מה חשוב להבין לפני שסוגרים אולם${cityBet}`,
      trustParagraphs: (_cityLabel: string, cityBet: string, venuePreview: string) => [
        `בחירת אולם${cityBet} היא לא רק עניין של מחיר ותאריך פנוי. צריך להבין איך המקום מרגיש בזמן אמת, האם הרחבה נראית טבעית, איפה עומדת עמדת המוזיקה ואיך האורחים זזים בין קבלת הפנים, האוכל והריקודים.`,
        `כשיש בעיר רשימה רחבה של מקומות כמו ${venuePreview}, ההבדל נמצא בפרטים הקטנים: מי מנהל את האירוע, כמה מהר אפשר לתאם ספקים, האם יש מגבלות ווליום ומה קורה אם הלו״ז זז.`,
        'מבחינת מוזיקה, אולם טוב הוא מקום שנותן לדיג׳יי לראות את הרחבה, לשמוע נכון את הסאונד ולבנות אנרגיה בלי שהאירוע מרגיש מקוטע בין שלבים.',
      ],
      workTitle: (_cityLabel: string, cityBet: string) => `צ׳ק ליסט קצר לסיור באולמות${cityBet}`,
      workBullets: (_cityLabel: string, cityBet: string) => [
        `לצמצם את הרשימה ל-3-5 אולמות${cityBet} לפי כמות אורחים, תקציב, סגנון ונוחות הגעה.`,
        'בסיור במקום לבדוק לא רק איך האולם נראה ריק, אלא איך הוא עובד בזמן אירוע: רחבה, בר, שירות, תאורה, כניסות וסאונד.',
        'לפני חתימה לוודא מה כלול במחיר, אילו ספקים חייבים לעבוד עם המקום, מה שעות האירוע ומה המדיניות לגבי הגברה, אפקטים ונגנים.',
        'אחרי שסוגרים אולם, להעביר לדיג׳יי את שם המקום, איש קשר, מגבלות טכניות, לו״ז ראשוני וכל רגע מיוחד שמתוכנן.',
      ],
      faqs: (_cityLabel: string, cityBet: string, venues: readonly string[]) => [
        {
          q: `איך בוחרים אולם${cityBet} בלי להתבלבל מכמות האפשרויות?`,
          a: 'מתחילים משלושה מסננים: כמות אורחים, סגנון האירוע ותקציב. אחרי זה בודקים לוגיסטיקה, חניה, רחבה, סאונד, שירות וזמינות. רק כשכל אלה מסתדרים, כדאי להתקדם לפגישה רצינית עם האולם.',
        },
        {
          q: `אילו אולמות כדאי לבדוק${cityBet}?`,
          a: `ברשימה שלנו לעיר מופיעים בין היתר: ${venues.join(', ')}. הרשימה נועדה לתת נקודת פתיחה, ועדיין חשוב לוודא זמינות, פעילות עדכנית והתאמה אישית מול כל מקום.`,
        },
        {
          q: 'מה חשוב לבדוק מול האולם לפני שסוגרים?',
          a: 'חשוב לבדוק מה כלול במחיר, כמה אנשי צוות יש באירוע, האם יש חניה, האם יש הגבלת רעש, האם אפשר להביא ספקים חיצוניים, איפה עומדת עמדת הדי ג׳יי ומה קורה במקרה של שינוי בכמות האורחים.',
        },
        {
          q: 'איך האולם משפיע על המוזיקה והרחבה?',
          a: 'האולם משפיע מאוד: אקוסטיקה, מיקום הרחבה, גודל החלל, עמדת הדי ג׳יי והתאורה קובעים כמה קל להחזיק רחבה פעילה. לכן כדאי לתאם מראש בין האולם לדיג׳יי ולא להשאיר את זה ליום האירוע.',
        },
      ],
      articleSection: (_cityLabel: string, cityBet: string) => `בחירת אולם${cityBet}`,
      planningItemDescription: (_cityLabel: string, cityBet: string, venuePreview: string) =>
        `בחירת אולם${cityBet} מתחילה בהשוואה בין אולמות אירועים וגני אירועים, אבל לא נעצרת במחיר או בתמונות. בסיור כדאי לבדוק רחבת ריקודים, אקוסטיקה, הגברה, חניה, נגישות ואולמות מוכרים כמו ${venuePreview}.`,
      keywords: (_cityLabel: string, cityBet: string) => [
        `אולמות אירועים${cityBet}`,
        `אולם אירועים${cityBet}`,
        `גני אירועים${cityBet}`,
      ],
    },
    sections: {
      חתונה: {
        title: 'ארגון חתונה',
        subtitle: 'מדריכים מעשיים לתכנון חתונה מלאה: בחירת שירי חופה וסלואו, בניית לו״ז מוזיקלי, שילוב אטרקציות עדכניות, תיאום נגנים והחלטות קטנות שעושות הבדל גדול ברחבה.',
        keys: ['wedding_chuppah_song', 'wedding_timeline', 'wedding_attractions', 'wedding_musicians', 'wedding_slow_song', 'wedding_music'],
      },
      חינה: {
        title: 'ארגון חינה',
        subtitle: 'מדריכי חינה לפי מסורת, משפחה ואווירה: כניסות, לו״ז, נגנים, אטרקציות, מקצבים עדתיים ומעברים נכונים בין טקס מרגש לבין רחבה שמחה וצבעונית.',
        keys: ['henna_entrance', 'henna_timeline', 'henna_attractions', 'henna_musicians', 'henna_music', 'henna_moroccan', 'henna_kurdish', 'henna_tunisian', 'henna_yemenite', 'henna_indian', 'henna_iraqi', 'henna_persian'],
      },
      'בר-מצווה': {
        title: 'ארגון בר מצווה',
        subtitle: 'מדריכים לתכנון בר או בת מצווה עם כניסה חזקה, שיר מוקלט, לו״ז נכון, אטרקציות לנוער, מוזיקה שמתאימה לחברים ולמשפחה ורחבה שלא נתקעת באמצע האירוע.',
        keys: ['bar_bat_entrance', 'bar_bat_timeline', 'bar_bat_attractions', 'bar_bat_musicians', 'bar_bat_recording', 'bar_bat_music'],
      },
      אירוע: {
        title: 'ארגון אירוע',
        subtitle: 'כלים לתכנון אירוע פרטי או עסקי בצורה מקצועית: בחירת אולם, מוזיקה לפי קהל, כניסה, לו״ז, אטרקציות, נגנים, אפטר פארטי, תאורה ואפקטים שעובדים יחד ולא מרגישים כמו עומס.',
        keys: ['event_entrance', 'event_music', 'event_music_timeline', 'event_attractions', 'event_musicians'],
      },
    },
    articles: {
      wedding_chuppah_song: {
        title: 'בחירת שיר כניסה לחופה',
        sectionTitle: 'איך לבחור שיר כניסה לחופה',
        description: 'שיר הכניסה לחופה הוא הרגע שבו כל העיניים עליכם. כך בוחרים שיר שמרגיש אישי, מרגש ונכון לקצב של הטקס.',
        carouselDescription: 'שיר כניסה לחופה צריך להתאים לזוג, לקצב ההליכה, לסדר המלווים ולרגע שבו כולם עומדים לפני הטקס. במדריך תמצאו איך לבחור שיר חופה מרגש, איפה להתחיל אותו, מתי להגיע לשיא, ואיך לתאם עם הדיג׳יי, הצלמים, האולם, נגנים, עשן או זיקוקים קרים בלי להפוך את הכניסה ללחוצה או טכנית.',
        imageAlt: 'זוג בכניסה לחופה עם מוזיקה מרגשת',
        intro: 'שיר חופה טוב לא נבחר רק לפי מה שפופולרי עכשיו. הוא צריך להתאים לאופי שלכם, לקצב ההליכה, למיקום החופה ולתחושה שאתם רוצים להשאיר לאורחים ברגע הראשון.',
        bullets: ['בחרו שיר שמרגיש שלכם גם בלי להסביר אותו.', 'בדקו שהפתיחה של השיר עובדת טוב לכניסה ולא מתחילה לאט מדי.', 'התאימו את אורך השיר למרחק ההליכה ולסדר הכניסות.', 'תאמו מראש עם הדיג׳יי את נקודת ההתחלה, הווליום והמעבר לטקס.'],
        cta: 'רוצים לבנות כניסה לחופה עם תזמון מדויק ושיר שמרגיש באמת שלכם? נדבר ונבנה את הרגע הזה יחד.',
        trustParagraphs: [
          'בכניסה לחופה אין מקום לאלתורים של הרגע האחרון. לפעמים השיר מדהים, אבל הפתיחה שלו ארוכה מדי, הווליום לא נכון או נקודת הכניסה לא מתאימה למרחק בין הדלת לחופה. אלה הפרטים הקטנים שעושים הבדל גדול ברגע שכולם מסתכלים.',
          'אני בודק עם הזוג מי נכנס לפני מי, כמה זמן לוקחת ההליכה, האם יש כניסה נפרדת לחתן ולכלה, ואיפה נכון להתחיל את השיר כדי שהשיא יגיע בדיוק כשהזוג עומד תחת החופה.',
          'אם יש זיקוקים קרים, עשן, נגנים או כניסה עם משפחות, חשוב לתאם את הכל מראש מול האולם והצלמים. המטרה היא שהרגע ירגיש מרגש וטבעי, לא טכני ולא לחוץ.',
        ],
        workBullets: [
          'בחירת שיר או גרסה שמתאימה לקצב ההליכה ולסגנון הזוג.',
          'סימון נקודת התחלה, נקודת שיא ונקודת יציאה מהשיר.',
          'תיאום סדר הכניסות של ההורים, החתן, הכלה והמלווים.',
          'בדיקת ווליום נכון לחופה פתוחה, אולם סגור או גן אירועים.',
          'תיאום מול נגנים, זיקוקים קרים, עשן וצלמים אם משלבים אפקטים.',
        ],
      },
      wedding_timeline: {
        title: 'תכנון לו״ז חתונה',
        sectionTitle: 'איך בונים לו״ז חתונה נכון',
        description: 'לו״ז חתונה מסודר מחבר בין קבלת פנים, חופה, סלואו ורחבה בלי נפילות אנרגיה, עם תזמון נכון לספקים, למשפחה ולרגעי השיא.',
        carouselDescription: 'לו״ז חתונה טוב הוא מה שמחזיק את הערב: קבלת פנים, חופה, שבירת כוס, אוכל, סלואו, פתיחת רחבה ואפטר פארטי. המדריך מסביר איך לתכנן זמנים, להשאיר מרווחים לעיכובים, לתאם ספקים, ולבנות מעבר מוזיקלי נכון כדי שהחתונה לא תיתקע בין שלבים ולא תאבד אנרגיה ברחבה.',
        imageAlt: 'תכנון לוח זמנים מוזיקלי לחתונה',
        intro: 'הלו״ז הוא השלד של החתונה. כשהוא ברור, הדיג׳יי, האולם, הצלם והזוג יודעים מתי כל רגע קורה ואיך עוברים אליו בלי לחץ.',
        bullets: ['קבעו מראש זמני קבלת פנים, חופה, אוכל וסלואו.', 'השאירו מרווחים קטנים לעיכובים טבעיים.', 'תאמו נקודות שיא כמו שבירת כוס וכניסת זוג.', 'חברו כל מעבר מוזיקלי לאנרגיה הרצויה ברחבה.'],
        cta: 'לו״ז מוזיקלי טוב מוריד לחץ ומחזיק את הערב בקצב נכון מהחופה ועד הסוף.',
        trustParagraphs: [
          'בחתונה, הלו״ז משפיע ישירות על הרחבה. חופה שמתחילה מאוחר מדי, אוכל שנמשך יותר מדי או סלואו שנכנס אחרי שהקהל כבר התפזר יכולים לשבור אנרגיה גם באירוע עם מוזיקה מצוינת.',
          'אני מסתכל על הלו״ז כמו רצף של אנרגיות: קבלת פנים נעימה, חופה מרגשת, שבירת כוס שמרימה את כולם, אוכל בלי איבוד קשב, פתיחת רחבה חזקה ואז בנייה הדרגתית עד אפטר פארטי.',
          'כשהספקים יודעים מראש מתי כל רגע קורה, אין צעקות באוזן ואין ריצות בין עמדות. הכל זורם נקי יותר, וגם הזוג מרגיש שיש מישהו שמחזיק את הקצב של הערב.',
        ],
        workBullets: [
          'זמני קבלת פנים, חופה, מנה ראשונה, עיקרית, סלואו ופתיחת רחבה.',
          'נקודות שבהן צריך מוזיקה מדויקת: שבירת כוס, כניסה לאולם, סלואו ואפטר פארטי.',
          'מרווחים לעיכובים טבעיים בלי להפוך את הערב לאיטי.',
          'תיאום מול מנהל האירוע, צלמים, נגנים ואטרקציות.',
          'החלטה איפה שומרים על רגש ואיפה מעלים קצב בלי להסס.',
        ],
      },
      wedding_attractions: {
        title: 'אטרקציות לחתונה',
        sectionTitle: 'איך לבחור אטרקציות לחתונה',
        description: 'אטרקציות לחתונה צריכות להוסיף חוויה, תמונות ואנרגיה בלי לגנוב פוקוס מהמוזיקה ומהרחבה. הבחירה הנכונה משלבת אפקט מרגש, תזמון ותפעול נקי.',
        carouselDescription: 'אטרקציות לחתונה עובדות רק כשהן מחוברות לרגע הנכון: זיקוקים קרים בכניסה, עשן כבד או בלונים בסלואו, לייזרים בשיא הרחבה, אותיות מוארות, וידאו AI או אפטר פארטי. במדריך תראו איך לבחור אטרקציות שמוסיפות תמונות ואנרגיה בלי לחסום רחבה, להפריע לצילום או לעצור את המוזיקה.',
        imageAlt: 'אטרקציות לחתונה ברחבת הריקודים',
        intro: 'בחתונות של היום אפשר לשלב זיקוקים קרים לכניסה, בלונים מתפוצצים לסלואו, תותחי עשן, אותיות מוארות של חתן וכלה כמו E&A, לייזרים, מתנפחים מעוצבים, וידאו AI, עמדות צילום ואפטר פארטי לפי סגנון מוזיקלי. הסוד הוא לא לקחת הכל, אלא לבחור מה באמת מתאים לאופי שלכם ולמקום.',
        bullets: ['בחרו אטרקציות שמתאימות לקהל ולא רק לטרנד: סלואו רומנטי יכול לעבוד עם בלונים או עשן, וחתונה צעירה יכולה לקבל אפטר פארטי עם ירידה של הדיג׳יי לרחבה.', 'ודאו שהאטרקציות לא חוסמות את הרחבה, לא מסתירות את הצלם ולא דורשות הפסקה ארוכה מדי מהמוזיקה.', 'תאמו עם הדיג׳יי והאולם את נקודת ההפעלה של זיקוקים קרים, לייזרים, עשן או וידאו AI כדי שהאפקט ייפול בדיוק על השיא המוזיקלי.', 'עדיף לבחור שניים או שלושה רגעי וואו מדויקים מאשר לפזר הרבה גימיקים שגורמים לאירוע להרגיש עמוס.'],
        cta: 'אפשר לשלב אטרקציות בצורה שמחזקת את החופה, הסלואו והרחבה בלי להפריע לזרימה של החתונה.',
        trustParagraphs: [
          'אטרקציה טובה בחתונה היא לא משהו שמכניסים כי “כולם עושים”. היא צריכה לשרת רגע ברור: כניסה, סלואו, פתיחת רחבה, אפטר פארטי או תמונה משפחתית חזקה.',
          'ראיתי אירועים שבהם יותר מדי אפקטים עצרו את הרחבה במקום להרים אותה. לכן אני מעדיף לבחור מעט רגעים מדויקים: זיקוקים קרים בכניסה, בלונים בסלואו, לייזרים בשיא הרחבה או וידאו AI שמופיע בזמן נכון.',
          'הבדיקה החשובה היא תפעולית: האם יש אישור אולם, מי מפעיל, איפה עומדים הצלמים, האם העשן מפריע לחופה, והאם האפקט יושב על הדרופ או נכנס באיחור.',
        ],
        workBullets: [
          'בחירת אטרקציות לפי אופי הזוג ולא רק לפי טרנד.',
          'תזמון זיקוקים, עשן, בלונים, לייזרים או אותיות מוארות מול המוזיקה.',
          'בדיקת מגבלות אולם: חשמל, גובה, בטיחות, צילום ומיקום ברחבה.',
          'הפרדה בין רגעי רגש לבין רגעי מסיבה כדי לא לערבב יותר מדי.',
          'בניית אפטר פארטי לפי סגנון הקהל שנשאר לרקוד עד מאוחר.',
        ],
      },
      wedding_musicians: {
        title: 'נגנים לחתונה',
        sectionTitle: 'מתי כדאי לשלב נגנים בחתונה',
        description: 'נגנים לחתונה יכולים להוסיף רגש לקבלת פנים, לחופה, לסלואו או לפתיחת הרחבה: כנרית לחתונה, סקסופון לחתונה, בוזוקי, גיטרה, דרבוקות, מתופפים, זמרים, קלידים או להקה לקבלת פנים.',
        carouselDescription: 'נגנים לחתונה יכולים לשדרג רגעים מאוד ספציפיים: כנרית לחופה או לסלואו, סקסופון לחתונה בקבלת פנים או ברחבה, בוזוקי וגיטרה לאווירה ים תיכונית, ודרבוקות או מתופפים לפתיחת רחבה. זמרים, קלידים או להקה לקבלת פנים מתאימים כשיש להם מקום ברור בלו״ז ותיאום מלא עם הדיג׳יי.',
        imageAlt: 'נגנים לחתונה בקבלת פנים',
        intro: 'בחתונה לא כל נגן מתאים לכל שלב. כנרית לחתונה יכולה לעבוד מדהים בחופה או בסלואו, סקסופון לחתונה מתאים לקבלת פנים ולרחבה, בוזוקי או גיטרה נותנים צבע ים תיכוני, ודרבוקות או מתופפים יכולים לפתוח רחבה באנרגיה גבוהה. זמרים, קלידים או להקה לקבלת פנים מתאימים כשמחפשים אווירה חיה יותר כבר בתחילת הערב.',
        bullets: ['בחרו את סוג הנגן לפי הרגע: כנרית לחופה, סקסופון לקבלת פנים, בוזוקי או גיטרה לאווירה ים תיכונית, דרבוקות ומתופפים לפתיחת רחבה.', 'תאמו סולמות, שירים, נקודות כניסה וסיומות כדי שהנגן לא יתנגש עם המיקס של הדיג׳יי.', 'בדקו מראש מיקרופונים, DI, חשמל, מוניטור וחיבור סאונד מתאים באולם או בגן האירועים.', 'שמרו על שילוב קצר ומדויק כדי שהנגן יוסיף רגש ואנרגיה בלי להפוך את החתונה למופע ארוך.'],
        cta: 'שילוב נכון של נגנים לחתונה יכול להפוך חופה, קבלת פנים או פתיחת רחבה לרגע חי ומרגש יותר.',
        trustParagraphs: [
          'נגנים בחתונה יכולים להיות מדהימים, אבל רק כשהם יודעים איפה הם נכנסים ואיפה הם מפנים מקום לדיג׳יי. כנרית לחופה, סקסופון לקבלת פנים, בוזוקי בקטע ים תיכוני, גיטרה אקוסטית, דרבוקות אחרי שבירת כוס או מתופפים בפתיחת הרחבה הם תפקידים שונים לגמרי.',
          'הטעות הנפוצה היא להביא נגן טוב בלי תיאום מוזיקלי. צריך לדעת אילו שירים מנגנים, באיזה סולם, מתי הנגן מצטרף למיקס, האם הוא צריך מיקרופון, DI, מוניטור, קלידים או חיבור אחר לסאונד, ואיך הוא יוצא בלי לעצור את הרחבה.',
          'כשהשילוב נכון, הנגן לא “גונב הצגה” אלא מוסיף שכבה חיה לרגע הנכון. זה מורגש במיוחד בקבלת פנים אלגנטית, בחופה מרגשת או בפתיחת רחבה שצריכה עוד דחיפה.',
        ],
        workBullets: [
          'בחירת נגן לפי רגע: כנרית לחופה, סקסופון לחתונה, בוזוקי, גיטרה, דרבוקות, מתופפים, זמרים, קלידים או להקה לקבלת פנים.',
          'תיאום רשימת שירים, סולמות, כניסות, סיומות וקטעי אלתור מול הדיג׳יי.',
          'בדיקת צרכי סאונד מול האולם: מיקרופונים, DI, מוניטור, חשמל ומיקום הנגנים.',
          'קביעת משך הופעה כדי שהנגן יחזק את החתונה ולא יעייף את הקהל.',
          'תיאום מעבר נקי בין נגינה חיה לבין סט הדיג׳יי ברחבה.',
        ],
      },
      wedding_slow_song: {
        title: 'בחירת שיר לריקוד סלואו',
        sectionTitle: 'איך לבחור שיר סלואו לחתונה',
        description: 'שיר הסלואו צריך להחזיק רגע אינטימי מול כל האורחים. הנה דרך פשוטה לבחור שיר מרגש בלי להרגיש מאולצים.',
        carouselDescription: 'שיר סלואו לחתונה צריך להרגיש אישי ולא מבוים: לבחור גרסה נכונה, לקצר אם צריך, להחליט מתי המשפחה מצטרפת, ולתאם עשן כבד, בלונים מתפוצצים, זיקוקים קרים או אותיות בלי להסתיר את הזוג. המדריך נותן דרך לבחור ריקוד סלואו מרגש, טבעי, ובקצב שמוביל נכון לפתיחת הרחבה.',
        imageAlt: 'רחבת חתונה בזמן ריקוד סלואו',
        intro: 'הסלואו הוא רגע קצר, אבל כשהוא מתוכנן נכון הוא נשאר בזיכרון. השיר צריך להתאים לכם, לאורך הריקוד, לאופי המשפחה ולרמת הדרמה שאתם רוצים ליצור.',
        bullets: ['בחרו שיר שאתם באמת אוהבים, גם אם הוא פחות מוכר.', 'אל תבחרו שיר ארוך מדי אם אין כוריאוגרפיה מלאה.', 'חשבו מראש אם תרצו להזמין את המשפחה והחברים להצטרף באמצע.', 'בקשו מהדיג׳יי להכין גרסה מקוצרת או נקודת יציאה נקייה במידת הצורך.'],
        cta: 'אפשר להפוך את הסלואו לרגע טבעי, מרגש ולא מביך. נבחר יחד את השיר והמבנה שמתאימים לכם.',
        trustParagraphs: [
          'סלואו טוב לא חייב להיות דרמטי מדי. לפעמים דווקא שיר פשוט, עם עריכה נכונה וכניסה נקייה של המשפחה באמצע, מרגיש הרבה יותר אמיתי מריקוד ארוך שהזוג רק מחכה שייגמר.',
          'אני בודק עם הזוג אם הם רוצים ריקוד מלא, חצי דקה אינטימית ואז הצטרפות משפחה, או סלואו קצר שמוביל ישר לפתיחת רחבה. לכל בחירה יש עריכה מוזיקלית אחרת.',
          'אם משלבים בלונים מתפוצצים, עשן כבד, זיקוקים קרים או אותיות, צריך שהאפקט יגיע ברגע הנכון ולא יסתיר את הזוג או את הצילום.',
        ],
        workBullets: [
          'בחירת שיר שמתאים לזוג ולא רק לרשימות מומלצות.',
          'קיצור השיר או בניית נקודת יציאה מקצועית.',
          'החלטה מתי המשפחה והחברים מצטרפים לריקוד.',
          'תיאום אפקטים כמו בלונים, עשן או זיקוקים מול הצלם והאולם.',
          'מעבר נקי מהסלואו לפתיחת רחבה בלי נפילת אנרגיה.',
        ],
      },
      wedding_music: {
        title: 'בחירת מוזיקה לחתונה',
        sectionTitle: 'איך לבחור מוזיקה לחתונה',
        description: 'מוזיקה לחתונה צריכה לחבר בין המשפחות, החברים והזוג. הבחירה הנכונה מתחילה בהבנת הקהל וממשיכה בשילוב מדויק של סגנונות לאורך הערב.',
        carouselDescription: 'בחירת מוזיקה לחתונה מתחילה מהקהל ולא מפלייליסט אקראי: משפחה, חברים, צעירים, מבוגרים, קהל דתי או חילוני, מזרחית, ישראלי, לטיני, היפ הופ, נוסטלגיות, טראנס וטכנו. במדריך תראו איך בונים רצף מוזיקלי לקבלת פנים, חופה, שבירת כוס, סלואו, רחבה ואפטר פארטי בלי לאבד את הטעם של הזוג.',
        imageAlt: 'דיג׳יי מתכנן מוזיקה לחתונה',
        intro: 'חתונה טובה לא נבנית מפלייליסט אחד. יש קבלת פנים, חופה, שבירת כוס, סלואו, אוכל, רחבה ואפטר פארטי. בכל שלב צריך להבין מי נמצא מולכם: חברים צעירים, משפחה מבוגרת, קהל דתי, קהל חילוני, אורחים שאוהבים מזרחית, נוסטלגיות, לטינית, היפ הופ, טראנס, טכנו או להקות ישראליות.',
        bullets: ['התחילו מהקהל: כמה צעירים מגיעים, כמה מבוגרים, האם יש קהל דתי ומה הסגנונות שמחברים את שתי המשפחות.', 'רשמו זמרים ולהקות שאתם והמשפחה באמת אוהבים: מזרחית, ישראלי, חסידי ודתי, לטיני, פופ, היפ הופ, נוסטלגיות, טראנס וטכנו.', 'הפרידו בין שירים שחייבים להיות לבין שירים שלא מתאימים לכם, כדי שהדיג׳יי יוכל לקרוא את הרחבה בלי לפגוע בטעם שלכם.', 'בנו זרימה: קבלת פנים נעימה, חופה מרגשת, פתיחת רחבה שמחברת את כולם, ואז קצב שעולה לפי הקהל שנשאר לרקוד.'],
        cta: 'בחירת מוזיקה לחתונה היא שילוב בין טעם אישי לקריאת קהל מקצועית. כשמדייקים את זה מראש, הרחבה מרגישה טבעית ולא מאולצת.',
        trustParagraphs: [
          'בחתונה יש שני קהלים לפחות: המשפחה והחברים. לפעמים יש גם צד דתי, צד חילוני, חברים מהצבא, קהל רוסי, קהל מרוקאי, אורחים שאוהבים טראנס וחברים שרוצים היפ הופ. התפקיד של הדיג׳יי הוא לא לרצות את כולם בכל שיר, אלא לבנות רצף שבו כולם מקבלים מקום.',
          'אני לא מבקש מהזוג פלייליסט של 200 שירים. הרבה יותר חשוב להבין מה הסגנון שלכם, מי האורחים, מה אסור להשמיע, ואילו רגעים חייבים להיות אישיים. משם אפשר לקרוא את הרחבה בזמן אמת בלי לאבד את הזהות שלכם.',
          'מוזיקה לחתונה עובדת כשהיא נבנית בשכבות: קבלת פנים נעימה, חופה מרגשת, פתיחת רחבה שמחברת משפחות, סטים צעירים יותר בהמשך ואפטר פארטי למי שנשאר עד הסוף.',
        ],
        workBullets: [
          'מיפוי הקהל לפי גיל, משפחות, חברים, קהל דתי וסגנונות אהובים.',
          'רשימת חובה קצרה לצד רשימת שירים שלא תרצו לשמוע.',
          'בחירת סגנונות לקבלת פנים, חופה, רחבה ואפטר פארטי.',
          'שילוב מזרחית, ישראלי, לטיני, היפ הופ, נוסטלגיות, טראנס וטכנו לפי התגובה ברחבה.',
          'שמירה על זהות הזוג לצד קריאת קהל בזמן אמת.',
        ],
      },
      henna_entrance: {
        title: 'כניסה לחינה',
        sectionTitle: 'איך מתכננים כניסה לחינה',
        description: 'כניסה לחינה היא הרגע שבו הארוס והארוסה נכנסים לאולם ולרחבת הריקודים עם שיר כניסה לחינה, תלבושת מסורתית ומשפחה שמלווה את פתיחת הערב.',
        carouselDescription: 'כניסה לחינה היא הרגע שבו הארוס והארוסה נכנסים לאולם ולרחבת הריקודים עם שיר כניסה לחינה, תלבושת חינה מסורתית והמשפחה הקרובה סביבם. במדריך תראו איך מסדרים את סדר הכניסה, איך בוחרים שיר שמתאים לעדה ולאופי המשפחה, ואיך עוברים בצורה טבעית לטקס מריחת החינה, לטקס הענקת הזהב או לריקודים.',
        imageAlt: 'כניסה חגיגית לחינה',
        intro: 'כניסה לחינה היא לא רק בחירה של שיר שמח. זה הרגע שבו הארוס והארוסה נכנסים לאולם או לרחבת הריקודים עם תלבושת חינה מסורתית, משפחה ומלווים. כשמסדרים מראש את סדר הכניסה, השיר והמעבר לטקס, הרגע מרגיש טבעי, משפחתי וחגיגי.',
        bullets: ['בחרו שיר כניסה לחינה שמתאים לעדה, לאופי המשפחה ולתלבושת של הזוג.', 'תאמו את סדר הכניסה של הארוס, הארוסה, ההורים והמלווים.', 'החליטו מראש אם הכניסה משותפת או בשלבים כדי שכל המשפחה תדע איפה לעמוד ומתי להיכנס.', 'הכינו מעבר ברור מהכניסה לטקס מריחת החינה, לטקס הענקת הזהב או לרחבת ריקודים קצרה.'],
        cta: 'כניסה לחינה טובה פותחת את הערב באנרגיה משפחתית, עם שיר נכון וסדר ברור שמכבד את המסורת.',
        trustParagraphs: [
          'כניסה לחינה מתחילה עוד לפני שהשיר מתנגן: מי עומד עם הארוס והארוסה מחוץ לאולם, מי נכנס ראשון, איפה עומדים ההורים והמלווים, ואיך נותנים למשפחה מקום בלי לעצור את הקצב.',
          'אני בודק מראש אם הכניסה לחינה היא משותפת או בשלבים, האם הזוג נכנס עם תלבושת חינה מסורתית, ואיזה שיר כניסה לחינה מתאים לעדה ולאופי של המשפחה.',
          'אחרי הכניסה צריך מעבר ברור לטקס מריחת החינה, לטקס הענקת הזהב, להחלפת תלבושת או לריקודים קצרים. כך הכניסה לא עומדת לבד, אלא פותחת את הערב בצורה טבעית ומכובדת.',
        ],
        workBullets: [
          'בחירת שיר כניסה לחינה לפי עדה, משפחה, תלבושת מסורתית וקצב רצוי.',
          'סידור כניסת הארוס והארוסה, ההורים, המלווים והצלמים.',
          'תיאום נקודת התחלה, ווליום וסיום לשיר הכניסה.',
          'הכנת מעבר ברור מהכניסה לטקס מריחת החינה, לטקס הענקת הזהב או לרחבת הריקודים.',
          'בדיקת ווליום וקצב שמתאימים גם למשפחה המבוגרת וגם לצעירים שמחכים לרחבה.',
        ],
      },
      henna_timeline: {
        title: 'תכנון לו״ז חינה',
        sectionTitle: 'איך בונים לו״ז לחינה',
        description: 'לו״ז חינה נכון מחבר כניסה, טקס מריחת חינה, טקס הענקת זהב, מנות וריקודים בלי שהערב ירגיש מקוטע, עם מקום למסורת ולמשפחה.',
        carouselDescription: 'לו״ז חינה צריך לעשות סדר בין כניסה, תלבושות, טקס מריחת חינה, טקס הענקת זהב, מנות וריקודים. המדריך מסביר איך לתזמן את המנות בין הכניסות והריקודים, איך לתת למסורת ולמשפחה מקום אמיתי, ואיך לתאם עם הדיג׳יי והאולם את המעבר ממוזיקה עדתית לרחבה שמחה.',
        imageAlt: 'תכנון לוח זמנים לחינה',
        intro: 'בחינה יש כמה חלקים שצריכים לשבת נכון אחד אחרי השני: כניסה, תלבושות, טקס מריחת חינה, טקס הענקת זהב, מנות וריקודים. לו״ז טוב נותן כבוד למסורת ולמשפחה, אבל עדיין שומר על קצב ברחבה.',
        bullets: ['סדרו מראש כניסה, החלפת תלבושות, טקס מריחת חינה, טקס הענקת זהב וריקודים.', 'תאמו עם האולם מתי יוצאות המנות בין הכניסות והריקודים.', 'תאמו עם הדיג׳יי איפה שומרים על מוזיקה עדתית ואיפה מעלים קצב.', 'אל תעמיסו יותר מדי עצירות בין חלקי הערב.'],
        cta: 'לו״ז מדויק לחינה שומר על מסורת, שמחה ואנרגיה.',
        trustParagraphs: [
          'בחינה יש נטייה טבעית לעצירות: תלבושות, טקס מריחת חינה, טקס הענקת זהב, מנות, תמונות ומשפחה שרוצה לקחת חלק. בלי לו״ז ברור, הערב יכול להרגיש כמו רצף של הפסקות במקום חגיגה אחת זורמת.',
          'אני בונה את הלו״ז כך שהטקסים יקבלו כבוד, אבל הרחבה לא תיפתח מאוחר מדי. צריך לדעת איפה יוצאות המנות, איפה נותנים למשפחה רגע, איפה מכניסים מעגלים, ואיפה עוברים למסיבה.',
          'הדגש הוא לא לקצר את המסורת, אלא לסדר אותה נכון. כשכל רגע מקבל מקום, כולל האוכל והמעברים בין הכניסות לריקודים, החינה מרגישה משפחתית, מכובדת ושמחה.',
        ],
        workBullets: [
          'סידור כניסה, תלבושות, טקס מריחת חינה, טקס הענקת זהב, מנות וריקודים.',
          'החלטה מתי משאירים מוזיקה עדתית ומתי עוברים לקצב כללי יותר.',
          'תיאום זמני צילום ותלבושות כדי שלא לעצור את הרחבה.',
          'שילוב נגנים או דרבוקות בנקודות שבהן הם באמת מוסיפים.',
          'שמירה על מעבר קצר וברור מהטקס למסיבה.',
        ],
      },
      henna_attractions: {
        title: 'אטרקציות לחינה',
        sectionTitle: 'איך לבחור אטרקציות לחינה',
        description: 'אטרקציות לחינה מוסיפות צבע, שמחה ואווירה משפחתית עם תלבושות לטקס החינה, צלם מגנטים, עמדות צילום, קיאק פירות, רקדנית בטן, בר קוקטיילים ומזכרות מיוחדות.',
        carouselDescription: 'אטרקציות לחינה יכולות לכלול תלבושות לטקס החינה לאורחים, צלם מגנטים, עמדות צילום מיוחדות, קיאק פירות, רקדנית בטן, בר קוקטיילים, מזכרות מיוחדות, אותיות מוארות, תאורה צבעונית או וידאו AI. במדריך תראו איך לבחור אטרקציות שמתאימות לחינה מרוקאית, תימנית, הודית או מעורבת בלי להפוך את הערב לעמוס מדי.',
        imageAlt: 'אטרקציות צבעוניות לחינה',
        intro: 'בחינה אפשר לשלב אטרקציות שנותנות צבע וחוויה לאורחים: תלבושות לטקס החינה לאורחים, צלם מגנטים, עמדות צילום מיוחדות, קיאק פירות, רקדנית בטן, בר קוקטיילים, מזכרות מיוחדות, אותיות מוארות, תאורה צבעונית או וידאו AI קצר שמספר את הסיפור של הזוג. הבחירה צריכה להתאים לאופי המשפחה ולאולם, ולא להפוך את החינה לערב עמוס מדי.',
        bullets: ['קיאק פירות מתאים לחינה שמחה וצבעונית, במיוחד כשהוא נכנס אחרי האוכל או בזמן שהרחבה כבר פתוחה ולא בזמן הטקס.', 'רקדנית בטן יכולה להוסיף רגע חזק לחינה מרוקאית, חינה תימנית, חינה פרסית או חינה מעורבת, אם משלבים אותה קצר ובתזמון נכון עם הדיג׳יי.', 'בר קוקטיילים, צלם מגנטים, עמדות צילום מיוחדות ומזכרות מיוחדות נותנים לאורחים חוויה שנשארת גם אחרי האירוע.', 'תלבושות לטקס החינה לאורחים יכולות לחזק את הצבע והמסורת, בעיקר כשמתאימים אותן לעדה, למשפחה ולסגנון של הערב.'],
        cta: 'אטרקציות נכונות לחינה מוסיפות צבע, מסורת ואנרגיה בלי לעצור את השמחה.',
        trustParagraphs: [
          'בחינה האטרקציות צריכות להרגיש חלק מהמסורת ולא כמו תוספת מקרית. קיאק פירות, רקדנית בטן, בר קוקטיילים, תלבושות לטקס החינה, עמדות צילום, מגנטים, מזכרות מיוחדות או וידאו צריכים להתחבר לסיפור של המשפחה.',
          'הטעות הנפוצה היא להעמיס יותר מדי דברים: כל ספק רוצה רגע, אבל הקהל רוצה להרגיש שמחה ורצף. לכן עדיף לבחור כמה רגעים מדויקים ולתת להם תזמון טוב.',
          'אני בודק איפה האטרקציה עומדת, מי מפעיל אותה, האם היא מפריעה למעגלים, והאם היא נכנסת על שיר נכון או יוצרת הפסקה טכנית.',
        ],
        workBullets: [
          'בחירת קיאק פירות, רקדנית בטן, בר קוקטיילים, מגנטים או עמדות צילום לפי אופי החינה.',
          'תזמון תלבושות לטקס החינה, מזכרות מיוחדות, וידאו AI ואותיות מוארות.',
          'שמירה על מקום לריקודים, לצילום ולמשפחה המבוגרת.',
          'בדיקת בטיחות ואישורי אולם לאפקטים מיוחדים.',
          'חיבור האטרקציות למוזיקה כדי שהן יחזקו את הטקס ולא יעצרו אותו.',
        ],
      },
      henna_musicians: {
        title: 'נגנים לחינה',
        sectionTitle: 'שילוב נגנים בחינה',
        description: 'נגנים לחינה מוסיפים קצב חי לכניסה, לטקס ולמעגלים: דרבוקיסט לחינה, כנרית לחינה, סקסופון, בוזוקי, גיטרה, דרבוקות, מתופפים, קלידים, זמרים או להקה.',
        carouselDescription: 'נגנים לחינה צריכים להתחבר למסורת, למשפחה ולקצב של הערב. דרבוקיסט לחינה מתאים במיוחד לכניסה ולמעגלים, כנרית לחינה יכולה להוסיף רגע חגיגי, וסקסופון, בוזוקי, גיטרה, דרבוקות, מתופפים או קלידים יכולים להשתלב כשיש תיאום נכון עם הדיג׳יי. זמרים או להקה מתאימים בסוף הרשימה, רק אם בונים להם חלק ברור בלו״ז.',
        imageAlt: 'נגנים ותופים באירוע חינה',
        intro: 'בחינה הנגנים צריכים להתאים לעדה, למשפחה ולרגע המדויק בערב. דרבוקיסט לחינה מתאים במיוחד לכניסה ולמעגלים, כנרית לחינה יכולה להוסיף רגע חגיגי, וסקסופון, בוזוקי, גיטרה, דרבוקות, מתופפים או קלידים יכולים לעבוד יפה כשיש להם מקום ברור בלו״ז ותיאום מלא מול הדיג׳יי. זמרים או להקה מתאימים בעיקר כשבונים להם חלק מוגדר בערב.',
        bullets: ['בחרו נגנים שמכירים את הסגנון העדתי שלכם: מרוקאית, תימנית, פרסית, עיראקית, כורדית, תוניסאית או הודית.', 'התאימו את הנגן לרגע: דרבוקיסט לחינה לכניסה ולמעגלים, כנרית לחינה לרגע חגיגי, סקסופון לפתיחה מרימה, ובוזוקי, גיטרה או קלידים לאווירה חיה.', 'תאמו מראש שירים, מקצבים, סולמות ורגעי כניסה כדי שהנגנים לא יתנגשו עם הדיג׳יי.', 'ודאו שיש סאונד מתאים: מיקרופונים, חיבורי DI, חשמל, מוניטור והגברה שמתאימה גם לטקס וגם לרחבה.'],
        cta: 'נגנים נכונים לחינה מוסיפים מסורת, קצב ומשפחתיות בלי לעצור את הריקודים.',
        trustParagraphs: [
          'נגנים בחינה יכולים לתת תחושה חיה ומשפחתית מאוד, במיוחד כשמשלבים דרבוקיסט לחינה, כנרית לחינה, סקסופון, בוזוקי, גיטרה, דרבוקות, מתופפים או קלידים שמתחברים למנהגי המשפחה. אבל הם צריכים להיות חלק מהערב, לא מופע נפרד שמנתק את הרחבה.',
          'החיבור בין הדיג׳יי לנגנים חשוב במיוחד בחינה, כי יש מעברים בין כניסה, טקס מריחת חינה, טקס הענקת זהב, מעגלים וריקודים. אם אין תיאום, מקבלים חפיפה מוזיקלית, ווליום לא נכון או עצירה מוזרה.',
          'כשהנגנים יודעים את הרגע שלהם, דרבוקיסט לחינה יכול לפתוח כניסה חזקה, מתופפים ודרבוקות יכולים להרים מעגלים, כנרית או סקסופון יכולים להוסיף רגע חגיגי, וזמרים או להקה יכולים להשתלב רק כשיש להם תפקיד ברור בערב.',
        ],
        workBullets: [
          'בחירת סוג הנגן: דרבוקיסט לחינה, כנרית לחינה, סקסופון, בוזוקי, גיטרה, דרבוקות, מתופפים, קלידים, זמרים או להקה.',
          'תיאום כניסות, מקצבים, שירים, סולמות וסיומות מול הדיג׳יי.',
          'בדיקת מיקרופונים, חיבורים, מוניטור והגברה מול המקום.',
          'החלטה אם הנגנים מלווים כניסה, טקס חינה, טקס הענקת זהב, מעגלים או רחבה.',
          'שמירה על איזון בין מסורת עדתית לבין מסיבה לכל האורחים.',
        ],
      },
      henna_music: {
        title: 'בחירת מוזיקה לחינה',
        sectionTitle: 'איך לבחור מוזיקה לחינה',
        description: 'מוזיקה לחינה צריכה לכבד את המסורת של המשפחה ולפתוח רחבה שמחה. הבחירה הנכונה משתנה בין חינה מרוקאית, חינה הודית, חינה פרסית, חינה תימנית, חינה עיראקית, חינה כורדית וחינה תוניסאית.',
        carouselDescription: 'בחירת מוזיקה לחינה מתחילה בעדה ובשירים שהמשפחה מכירה מהבית: חינה מרוקאית, חינה הודית, חינה פרסית, חינה תימנית, חינה עיראקית, חינה כורדית או חינה תוניסאית. במדריך תראו איך לשלב שירים עדתיים, מזרחית, ישראלי ולהיטים לצעירים, ואיך לעבור מטקס מריחת החינה לרחבת ריקודים שמחה.',
        imageAlt: 'בחירת מוזיקה לחינה עם קצב ומסורת',
        intro: 'בחינה יש רגעים שלא כדאי לפספס: כניסה, החלפת תלבושות, טקס מריחת חינה, טקס הענקת זהב, מעגלים וריקודים. כדי לבחור מוזיקה נכון צריך להבין מאיזו עדה מגיעה המשפחה, אילו שירים שרים בבית, איזה קצב מתאים לטקס ואיזה סגנון יפתח את הרחבה אחרי מריחת החינה.',
        bullets: ['אספו שירים עדתיים ומשפחתיים חשובים: שירי חינה מרוקאית, שירי חינה תימנית, שירים פרסיים לחינה, מוזיקה עיראקית לחינה, שירים כורדיים, מקצבים תוניסאיים או מוזיקה הודית לחינה.', 'שלבו בין מוזיקה אותנטית לבין מזרחית, ישראלי, לטינית, היפ הופ, נוסטלגיות וקצב עדכני כדי שגם הצעירים וגם המבוגרים ירגישו חלק.', 'בדקו אם יש קהל דתי או מסורתי שצריך שירים מתאימים יותר לפתיחה, לטקס הענקת הזהב או למעגלים.', 'תכננו עם הדיג׳יי את המעבר מהטקס לרחבה, כי שם החינה הופכת מאירוע משפחתי למסיבה שמחה.'],
        cta: 'מוזיקה לחינה טובה מרגישה כמו המשפחה שלכם: מכבדת, צבעונית, שמחה ומדויקת לקהל שנמצא באולם.',
        trustParagraphs: [
          'בחינה טובה נשענת על זיכרונות מהבית: שירים של ההורים, מקצבים של העדה, רגעים שהמשפחה מחכה להם. אם מתייחסים אליה כמו חתונה קטנה עם פלייליסט רגיל, מפספסים את הלב של האירוע.',
          'אני מבקש להבין מה חשוב למשפחה: חינה מרוקאית מסורתית, חינה תימנית, חינה עיראקית, חינה פרסית, חינה כורדית, חינה תוניסאית, חינה הודית או שילוב בין עדות. משם בונים רצף שמכבד את המבוגרים אבל עדיין עובד לצעירים.',
          'המעבר הקריטי הוא אחרי הטקס. שם צריך להפוך את האנרגיה ממשפחתית למסיבתית בלי למחוק את האופי של החינה.',
        ],
        workBullets: [
          'איסוף שירים עדתיים ומשפחתיים שחייבים להיכנס.',
          'הבנת הקהל המבוגר, הצעירים והקהל הדתי או המסורתי.',
          'שילוב מוזיקה עדתית עם מזרחית, ישראלי, לטינית, היפ הופ ונוסטלגיות.',
          'תכנון מעבר מהטקס לרחבה בצורה טבעית ולא חדה מדי.',
          'שמירה על כבוד למסורת לצד רחבה שמחה ועדכנית.',
        ],
      },
      henna_moroccan: {
        title: 'חינה מרוקאית',
        sectionTitle: 'איך מתכננים חינה מרוקאית שמחה',
        description: 'חינה מרוקאית מסורתית משלבת תלבושות, כניסות, טקס מריחת חינה, טקס הענקת זהב, מקצבים מרוקאיים והרבה משפחה. כך בונים ערב צבעוני עם מוזיקה לחינה מרוקאית שמרימה את כולם.',
        carouselDescription: 'חינה מרוקאית מסורתית צריכה לתת מקום לתלבושות, כניסות, טקס מריחת חינה, טקס הענקת זהב, שירי חינה מרוקאית ומעגלים משפחתיים. המדריך מסביר איך לשלב מקצבים מרוקאיים עם מזרחית ולהיטים עדכניים, איך לתזמן את הטקסים, ואיך לבנות ערב צבעוני שמכבד את המסורת אבל עדיין פותח רחבה חזקה.',
        imageAlt: 'רחבה שמחה באירוע חינה מרוקאית',
        intro: 'בחינה מרוקאית המוזיקה צריכה לתת מקום למסורת, לתלבושות, לכניסות ולטקס, אבל גם לפתוח רחבה שמחה ומעודכנת. האיזון בין שירי חינה מרוקאית, מעגלים משפחתיים וקצב גבוה הוא כל הסיפור.',
        bullets: ['תכננו מראש את סדר הכניסות, התלבושות וטקס החינה המרוקאית.', 'שלבו מקצבים מרוקאיים לצד מזרחית, ישראלי ולהיטים עכשוויים.', 'השאירו מקום לשירים משפחתיים שמכירים מהבית ולא רק לפלייליסט כללי.', 'תאמו עם הדיג׳יי את רגעי השיא של הטקס כדי למנוע עצירות מיותרות.'],
        cta: 'לחינה מרוקאית צריך פסקול שמכיר את המסורת וגם יודע להרים רחבה. אשמח לבנות איתכם את הערב.',
        trustParagraphs: [
          'חינה מרוקאית היא בדרך כלל צבעונית, משפחתית ומלאה ברגעים: תלבושות, כניסה, טקס מריחת חינה, טקס הענקת זהב ומעגלים. המוזיקה צריכה להחזיק את כל זה בלי להפוך את הערב למקוטע.',
          'חשוב לשלב שירים שמוכרים למשפחה ולא להסתפק בסט מזרחית רגיל. השירים המרוקאיים נותנים לאירוע את הזהות שלו, והלהיטים העכשוויים פותחים את הרחבה לצעירים.',
          'כשהכניסה, התלבושות והטקס מתוזמנים נכון, החינה מרגישה עשירה אבל לא עמוסה.',
        ],
        workBullets: [
          'סידור כניסות, תלבושות וטקס לפי המשפחה.',
          'שילוב מקצבים מרוקאיים עם מזרחית ולהיטים עדכניים.',
          'שמירת מקום לשירים משפחתיים שמכירים מהבית.',
          'תזמון מעברים בין טקס מריחת חינה, טקס הענקת זהב ורחבה.',
          'תיאום אטרקציות צבעוניות בלי להכביד על האירוע.',
        ],
      },
      henna_kurdish: {
        title: 'חינה כורדית',
        sectionTitle: 'תכנון מוזיקה לחינה כורדית',
        description: 'חינה כורדית מסורתית מביאה איתה אופי משפחתי, שירים כורדיים, מעגלים, מקצבים חמים ורחבה שמחה. כך משלבים בין שורשים למסיבה.',
        carouselDescription: 'חינה כורדית מסורתית נשענת על משפחה, מעגלים, שירים כורדיים ומקצבים שמוכרים למבוגרים. במדריך תראו איך לאסוף שירי חינה כורדית חשובים, איך לשלב בקשות משפחתיות בלי לשבור את הזרימה, ואיך לעבור בהדרגה למזרחית, ישראלי ולהיטים מוכרים כדי שגם הצעירים יישארו ברחבה.',
        imageAlt: 'חגיגה משפחתית ברחבת חינה כורדית',
        intro: 'בחינה כורדית חשוב לתת למשפחה להרגיש בבית. לצד מוזיקה כורדית לחינה ושירים שהמבוגרים מזהים, כדאי לבנות מעברים חכמים למזרחית ולהיטים שכל האורחים יכולים לרקוד איתם.',
        bullets: ['אספו מראש שירי חינה כורדית ושירים משפחתיים שחשובים להורים ולסבים.', 'בנו רצף כניסה וטקס ברור, בלי עומס מוזיקלי ובלי למשוך כל מעגל יותר מדי.', 'שלבו מעגלים, מזרחית ולהיטים מוכרים לפי הקהל.', 'השאירו מקום לבקשות מהמשפחה, אבל הגדירו גבולות כדי לשמור על זרימה.'],
        cta: 'אם חשוב לכם לשמור על המסורת וגם ליצור מסיבה חיה, נבנה תכנון מוזיקלי מדויק לחינה.',
        trustParagraphs: [
          'חינה כורדית נשענת הרבה על משפחתיות, מעגלים ושירים שהמבוגרים מזהים מיד. כשנותנים לזה מקום נכון, גם הצעירים נכנסים לאווירה כי הם מרגישים שהאירוע אמיתי ולא מועתק.',
          'אני בודק עם המשפחה אילו שירים חייבים להיות ואילו שירים עדיף להשאיר מחוץ לרשימה. בחינות כאלה חשוב מאוד לאזן בין בקשות משפחתיות לבין רצף מוזיקלי שמחזיק את הרחבה.',
          'המטרה היא לא להפוך את כל הערב למסורתי בלבד, אלא לבנות מעבר נעים ממקצבים כורדיים למזרחית, ישראלי ולהיטים מוכרים.',
        ],
        workBullets: [
          'איסוף שירים כורדיים ומשפחתיים לפני האירוע.',
          'תכנון מעגלים וכניסות בלי למשוך את הטקס יותר מדי.',
          'שילוב מזרחית ולהיטים מוכרים אחרי הרגעים המסורתיים.',
          'ניהול בקשות משפחתיות בזמן אמת בלי לשבור את הרחבה.',
          'שמירה על אופי משפחתי חם לצד מסיבה פתוחה.',
        ],
      },
      henna_tunisian: {
        title: 'חינה תוניסאית',
        sectionTitle: 'איך בונים חינה תוניסאית עם קצב נכון',
        description: 'חינה תוניסאית מסורתית היא שילוב של טקס, משפחתיות, שירים תוניסאיים ושמחה גדולה. הנה הדגשים שיעזרו למוזיקה להחזיק את הערב.',
        carouselDescription: 'חינה תוניסאית מסורתית משלבת שירים תוניסאיים, טקס מריחת חינה, טקס הענקת זהב, מעגלים ושמחה משפחתית. המדריך עוזר להבין איך לבחור שירי חינה תוניסאית, מתי לתת מקום לטקס ולמבוגרים, ואיך לחבר מקצבים תוניסאיים למזרחית ולהיטים עדכניים בלי שהערב ירגיש מקוטע או איטי מדי.',
        imageAlt: 'מוזיקה ורחבה באירוע חינה תוניסאית',
        intro: 'היופי בחינה תוניסאית הוא בשילוב בין רגעים מסורתיים לבין חגיגה פתוחה. כשהדיג׳יי מכיר שירי חינה תוניסאית, את הסדר המשפחתי ואת הקהל, הערב מרגיש טבעי ולא מקוטע.',
        bullets: ['הכינו רשימת שירים תוניסאיים ושירים משפחתיים שחייבים להיכנס.', 'סדרו מראש את רגעי הטקס, הענקת הזהב, הכניסות והמעגלים.', 'שלבו בין מקצבים תוניסאיים לבין מזרחית ולהיטים שמתאימים לצעירים.', 'שמרו על מעברים קצרים כדי שהאנרגיה לא תרד.'],
        cta: 'לחינה תוניסאית טובה צריך להרגיש את המשפחה ואת הרחבה יחד. נדייק את זה מראש.',
        trustParagraphs: [
          'חינה תוניסאית צריכה לשמור על שמחה גבוהה בלי לוותר על הרגעים המשפחתיים. יש חשיבות לשירים שהמשפחה מכירה, לטקס הענקת הזהב ולמעגלים, אבל גם לפתיחה נכונה של הרחבה.',
          'ההבדל בין ערב זורם לערב מקוטע נמצא במעברים: כמה זמן נשארים בטקס, מתי מכניסים שיר שמח, ומתי נותנים לקהל הצעיר להיכנס לתמונה.',
          'אני מתכנן את החלק התוניסאי כך שהוא יהיה מורגש וברור, אבל לא ירגיש כמו בלוק ארוך שמנתק את שאר האורחים.',
        ],
        workBullets: [
          'בחירת שירים תוניסאיים שהמשפחה באמת מחוברת אליהם.',
          'תכנון כניסה, טקס מריחת חינה וטקס הענקת זהב לפי הסדר המשפחתי.',
          'שילוב מקצבים תוניסאיים עם מזרחית ולהיטים עכשוויים.',
          'שמירה על מעברים קצרים כדי שהאנרגיה לא תרד.',
          'התאמת המוזיקה לצעירים ולמבוגרים באותו ערב.',
        ],
      },
      henna_yemenite: {
        title: 'חינה תימנית',
        sectionTitle: 'תכנון חינה תימנית עם מוזיקה שמחה',
        description: 'חינה תימנית מסורתית מלאה בקצב, לבוש, שירה תימנית ומשפחה. כך נותנים למסורת מקום וממשיכים למסיבה אנרגטית.',
        carouselDescription: 'חינה תימנית מסורתית צריכה לשמור על הלבוש, השירה, שירי חינה תימנית והקצב המשפחתי, אבל גם לדעת מתי לפתוח רחבה עדכנית. במדריך תראו איך לתכנן כניסה וטקס, איך לשלב שירה תימנית עם מזרחית וישראלי, ואיך לעבור מהמסורת למסיבה בלי לאבד את האופי של המשפחה.',
        imageAlt: 'חינה תימנית עם מוזיקה וריקודים',
        intro: 'בחינה תימנית יש חשיבות גדולה לפתיחה, לטקס, ללבוש ולשירים שמחברים את הדורות. תכנון נכון מאפשר לעבור משירי חינה תימנית לרחבה עדכנית בלי לאבד את האופי.',
        bullets: ['בחרו שירי כניסה וטקס שמתאימים למשפחה ולמנהגים.', 'תאמו מראש מתי נשארים בשירה תימנית ומתי עוברים מהטקס למסיבה.', 'שלבו שירים תימניים עם מזרחית, ישראלי ולהיטים עכשוויים.', 'ודאו שהסאונד מתאים גם לטקס וגם לרחבת ריקודים.'],
        cta: 'אפשר לשמור על החינה תימנית אותנטית ועדיין לבנות רחבה חזקה. זה מתחיל בתכנון מוזיקלי נכון.',
        trustParagraphs: [
          'חינה תימנית יכולה להיות מאוד מרגשת כשהשירים, הלבוש והמשפחה מקבלים מקום אמיתי. יש בה הרבה אופי, ולכן לא נכון לטשטש אותה בתוך מוזיקה כללית מדי.',
          'אני בודק אילו שירים חשובים לטקס, האם יש שירה משפחתית, מי מוביל את המעגלים, ומתי נכון לעבור לסט רחבה שידבר גם לצעירים.',
          'התכנון צריך לכבד את המסורת אבל לא להישאר תקוע בה. אחרי שהרגע התימני קיבל מקום, אפשר לפתוח רחבה עם מזרחית, ישראלי וקצב עדכני.',
        ],
        workBullets: [
          'בחירת שירי כניסה וטקס לפי מנהגי המשפחה.',
          'תיאום שירה משפחתית, מעגלים ורגעי ברכה.',
          'שילוב תימנית עם מזרחית, ישראלי ולהיטים לקהל צעיר.',
          'בדיקת סאונד לטקס ולרחבה כדי שהכל יישמע ברור.',
          'מעבר הדרגתי מהמסורת למסיבה בלי לאבד את האופי.',
        ],
      },
      henna_indian: {
        title: 'חינה הודית',
        sectionTitle: 'איך מתכננים חינה הודית צבעונית',
        description: 'חינה הודית מסורתית משלבת צבע, תלבושות, טקס משפחתי, כניסות ומוזיקה הודית לחינה. כך בונים ערב שמכבד את המסורת ונשאר זורם ברחבה.',
        carouselDescription: 'חינה הודית מסורתית מלאה בצבע, תלבושות, כניסות, טקס מריחת חינה, טקס הענקת זהב ומוזיקה הודית לחינה. במדריך תראו איך לבחור שירי חינה הודית, איך לתאם תלבושות וטקסים, ואיך לחבר קצב הודי עם מזרחית ולהיטים ישראליים כדי שהאירוע יישאר צבעוני, מכובד וזורם ברחבה.',
        imageAlt: 'חינה הודית צבעונית עם מוזיקה וריקודים',
        intro: 'בחינה הודית יש הרבה מקום לצבע, כניסות, טקס, תלבושות ורגעים משפחתיים. כדי שהערב ירגיש מקצועי ולא עמוס, צריך לחבר בין שירי חינה הודית, קצב הודי, מזרחית ולהיטים שהקהל הישראלי מכיר.',
        bullets: ['בחרו שירי כניסה וטקס שמתאימים למשפחה, למנהגים ולתלבושות.', 'תאמו מראש את סדר הכניסות, התלבושות, טקס מריחת החינה וטקס הענקת הזהב.', 'שלבו מקצבים הודיים עם מזרחית, ישראלי ולהיטים עכשוויים.', 'הכינו מעבר ברור מטקס חינה הודית לרחבה כדי לשמור על אנרגיה גבוהה.'],
        cta: 'חינה הודית טובה צריכה להרגיש צבעונית, משפחתית ומדויקת. נבנה יחד פסקול שמכבד את המסורת ומרים את הרחבה.',
        trustParagraphs: [
          'חינה הודית בדרך כלל עשירה מאוד בצבע, תלבושות ורגעים מצטלמים. דווקא בגלל זה חשוב שהתכנון יהיה נקי, כדי שהאירוע לא ירגיש כמו הרבה חלקים שלא מתחברים.',
          'המוזיקה צריכה לתת מקום לקצב ההודי ולמשפחה, אבל גם לדעת מתי לפתוח את הרחבה לקהל הישראלי עם מזרחית, פופ, לטינית ולהיטים מוכרים.',
          'אני מתייחס לחינה הודית כמו ערב עם שפה ויזואלית ומוזיקלית ברורה: כניסה מרשימה, טקס מכובד ומסיבה שממשיכה טבעי.',
        ],
        workBullets: [
          'תכנון כניסה צבעונית עם שיר וקצב שמתאימים למשפחה.',
          'סידור תלבושות, טקס מריחת חינה וטקס הענקת זהב בלי עומס מיותר.',
          'שילוב מקצבים הודיים עם מוזיקה מוכרת לקהל הישראלי.',
          'תיאום וידאו, תאורה ואטרקציות עם המוזיקה.',
          'מעבר ברור מהטקס לרחבה כדי לשמור על שמחה גבוהה.',
        ],
      },
      henna_iraqi: {
        title: 'חינה עיראקית',
        sectionTitle: 'תכנון מוזיקה לחינה עיראקית',
        description: 'חינה עיראקית מסורתית מביאה איתה חום משפחתי, שירים עיראקיים, מעגלים ומוזיקה שמחברת בין הדורות, עם תכנון שמכבד את הבית ופותח רחבה שמחה.',
        carouselDescription: 'חינה עיראקית מסורתית צריכה להרגיש חמה ומחוברת לבית: שירים עיראקיים, טקס מריחת חינה, טקס הענקת זהב, מעגלים ובקשות משפחתיות שמכירים מדורות קודמים. המדריך מסביר איך לאסוף שירי חינה עיראקית, איך לשלב מוזיקה עיראקית עם מזרחית ולהיטים לצעירים, ואיך לשמור על מעבר קצר ונקי מהטקס לרחבה.',
        imageAlt: 'חינה עיראקית עם משפחה ורחבת ריקודים',
        intro: 'בחינה עיראקית חשוב לתת מקום לשירים שמכירים מהבית, לטקסים ולמעגלים של המשפחה, אבל גם לבנות המשך טבעי למסיבה. התכנון המוזיקלי צריך לדעת מתי לשמור על חינה עיראקית אותנטית ומתי לפתוח את הרחבה לקהל הרחב.',
        bullets: ['אספו מראש שירי חינה עיראקית ושירים משפחתיים שחייבים להיכנס.', 'קבעו מתי מתקיימים הכניסה, טקס מריחת החינה, טקס הענקת הזהב והמעגלים.', 'שלבו מוזיקה עיראקית ומזרחית עם להיטים שמתאימים לצעירים.', 'שמרו על מעבר קצר ונקי בין הטקס לריקודים.'],
        cta: 'לחינה עיראקית חזקה צריך שילוב נכון בין מסורת, משפחה ורחבה חיה. אשמח לדייק איתכם את הערב מראש.',
        trustParagraphs: [
          'חינה עיראקית טובה מרגישה חמה ומחוברת לבית. השירים המשפחתיים והמעגלים הם לא “חלק קטן מהערב”, אלא מה שנותן לאירוע את הזהות שלו.',
          'חשוב להבין מראש אילו שירים באמת חשובים למשפחה, מי צפוי לבקש שירים בזמן אמת, ואיך מונעים מצב שבו בקשות עוצרות את הזרימה.',
          'אחרי שהחלק העיראקי מקבל מקום, אפשר לפתוח את הרחבה למזרחית, ישראלי ולהיטים שמתאימים לצעירים בלי שהאירוע ירגיש מנותק מהמסורת.',
        ],
        workBullets: [
          'איסוף שירים עיראקיים ומשפחתיים לפני האירוע.',
          'תכנון כניסה, טקס מריחת חינה, טקס הענקת זהב ומעגלים לפי סדר ברור.',
          'שילוב עיראקית עם מזרחית ולהיטים עדכניים.',
          'ניהול בקשות משפחתיות בלי להפוך את הערב למפוזר.',
          'מעבר קצר מהטקס לרחבה כדי לשמור על קצב.',
        ],
      },
      henna_persian: {
        title: 'חינה פרסית',
        sectionTitle: 'איך בונים חינה פרסית עם קצב נכון',
        description: 'חינה פרסית מסורתית משלבת אלגנטיות, טקס משפחתי, שירים פרסיים לחינה ומוזיקה שמחה. כך יוצרים ערב מכובד שגם יודע להפוך למסיבה.',
        carouselDescription: 'חינה פרסית מסורתית צריכה להרגיש אלגנטית, משפחתית ושמחה, עם שירים פרסיים לחינה, רגעי כניסה, טקס מריחת חינה וטקס הענקת זהב. במדריך תראו איך לבחור מוזיקה פרסית לחינה, מתי להכניס מזרחית וישראלי, ואיך לפתוח רחבה עדכנית בלי להפוך את הערב לאיטי או רשמי מדי.',
        imageAlt: 'חינה פרסית אלגנטית עם מוזיקה ושמחה',
        intro: 'בחינה פרסית יש מקום גדול לאווירה, למשפחה ולרגעים מדויקים. כשבונים את המוזיקה נכון, אפשר לתת לטקס חינה פרסית את הכבוד שלו ועדיין לשמור על רחבה עדכנית ושמחה לכל האורחים.',
        bullets: ['בחרו שירים פרסיים משמעותיים למשפחה, לכניסות ולטקס.', 'תכננו את רגעי הטקס כך שחינה פרסית מסורתית לא תהפוך לערב איטי מדי.', 'שלבו פרסית, מזרחית, ישראלי ולהיטים בינלאומיים לפי הקהל.', 'תאמו עם הדיג׳יי את נקודות השיא ואת המעבר לרחבה.'],
        cta: 'חינה פרסית טובה מרגישה מכובדת, שמחה וזורמת. נבנה אותה כך שכל רגע יקבל את המקום הנכון.',
        trustParagraphs: [
          'חינה פרסית בדרך כלל צריכה להרגיש מכובדת ואלגנטית, אבל עדיין שמחה. המוזיקה חייבת לשמור על הטעם המשפחתי ולא להפוך מהר מדי למסיבה כללית.',
          'אני בודק אילו שירים פרסיים חשובים למשפחה, האם יש רגעי כניסה מיוחדים, ואיפה נכון להכניס מזרחית, ישראלי או להיטים בינלאומיים.',
          'כשהחלק הפרסי מתוכנן נכון, הוא מוסיף אופי ויוקרה לערב בלי להאט אותו.',
        ],
        workBullets: [
          'בחירת שירים פרסיים למשפחה, כניסות וטקס.',
          'תכנון רגעי ברכה וטקס בלי עצירות ארוכות.',
          'שילוב פרסית עם מזרחית, ישראלי ולהיטים בינלאומיים.',
          'התאמת הווליום והקצב לקהל מבוגר וצעיר.',
          'פתיחת רחבה בצורה מכובדת אבל שמחה.',
        ],
      },
      bar_bat_recording: {
        title: 'הקלטת שירים לבר/בת מצווה',
        sectionTitle: 'הקלטת שיר לבר מצווה או בת מצווה',
        description: 'שיר מוקלט יכול להפוך כניסה, קליפ או רגע משפחתי למרגשים במיוחד. כך מתכננים אותו בלי לחץ ובלי זיופים מביכים.',
        carouselDescription: 'הקלטת שיר לבר מצווה או בת מצווה יכולה להשתלב בכניסה, בקליפ, בהפתעה מהמשפחה או ברגע אישי על הבמה. במדריך תראו איך לבחור פלייבק שמתאים לגיל ולקול, איך לכתוב מילים קצרות ולא מביכות, איך להשאיר זמן לחזרות, ואיך לתאם עם הדיג׳יי את נקודת ההשמעה והמעבר להמשך האירוע.',
        imageAlt: 'מיקרופון והקלטת שיר לבר מצווה או בת מצווה',
        intro: 'הקלטת שיר לבר או בת מצווה יכולה להיות רגע מרגש מאוד, במיוחד כשהטקסט אישי והביצוע מותאם לילד או לילדה. הסוד הוא לא להעמיס, אלא לבחור רעיון פשוט שעובד.',
        bullets: ['בחרו פלייבק מוכר שמתאים לקול ולגיל של החוגגים.', 'כתבו מילים קצרות וברורות, עם סיפור אישי ולא יותר מדי בדיחות פנימיות.', 'השאירו זמן לחזרות ולהקלטה מחדש אם צריך.', 'תאמו עם הדיג׳יי את נקודת ההשמעה באירוע ואת המעבר לשיר הבא.'],
        cta: 'רוצים לשלב שיר מוקלט בכניסה או בקליפ? אפשר לתכנן את זה כך שירגיש מקצועי ומרגש.',
        trustParagraphs: [
          'שיר מוקלט לבר או בת מצווה יכול להיות רגע מקסים, אבל הוא חייב להתאים לילד או לילדה. אם הטקסט ארוך מדי, הביצוע קשה מדי או הרגע באירוע לא נכון, זה עלול להרגיש מביך במקום מרגש.',
          'אני ממליץ לבחור פלייבק מוכר, לכתוב מילים פשוטות וברורות, ולשמור על אורך שמתאים לקהל. ילדים ונוער מאבדים סבלנות מהר, ולכן שיר קצר ומדויק עובד טוב יותר.',
          'חשוב להחליט אם השיר הוא חלק מהכניסה, קליפ, הפתעה מהמשפחה או רגע לפני ברכות. לכל שימוש יש תזמון אחר ומעבר מוזיקלי אחר.',
        ],
        workBullets: [
          'בחירת פלייבק שמתאים לקול, לגיל ולאופי החוגגים.',
          'כתיבת טקסט אישי אבל לא ארוך מדי.',
          'תכנון חזרות והקלטה בלי לחץ של הרגע האחרון.',
          'קביעת נקודת השמעה באירוע: כניסה, קליפ או הפתעה.',
          'מעבר נקי מהשיר המוקלט להמשך הרחבה או הברכות.',
        ],
      },
      bar_bat_entrance: {
        title: 'כניסה לבר/בת מצווה',
        sectionTitle: 'איך מתכננים כניסה לבר או בת מצווה',
        description: 'כניסה טובה נותנת לחוגג או לחוגגת רגע מרכזי בלי להפוך את האירוע למופע מוגזם. כך בונים אותה נכון.',
        carouselDescription: 'כניסה לבר מצווה או בת מצווה צריכה להרים את החוגג או החוגגת בלי להביך אותם מול החברים. המדריך מסביר איך לבחור שיר כניסה, האם להיכנס לבד, עם משפחה, חברים או רקדנים, איך לשלב עשן, זיקוקים קרים או אותיות שם, ואיך לשמור על כניסה קצרה שמובילה לברכה, קליפ או רחבה.',
        imageAlt: 'כניסה מרגשת לבר מצווה או בת מצווה',
        intro: 'כניסה לבר/בת מצווה צריכה להתאים לאופי של הילד או הילדה. יש מי שאוהבים כניסה דרמטית, ויש מי שירגישו טוב יותר עם רגע קליל, קצר ומשמח.',
        bullets: ['בחרו שיר שהחוגג או החוגגת באמת מתחברים אליו.', 'החליטו אם הכניסה תהיה לבד, עם חברים או עם המשפחה.', 'תכננו אורך קצר וברור כדי לשמור על תשומת הלב של הקהל.', 'חברו את הכניסה מיד לרחבה או לברכה כדי שהאירוע ימשיך לזרום.'],
        cta: 'כניסה טובה היא עניין של מינון ותזמון. נבנה אותה כך שתתאים בדיוק לחוגגים.',
        trustParagraphs: [
          'כניסה לבר או בת מצווה צריכה להרים את החוגגים, לא להביך אותם. יש ילדים שאוהבים להיות במרכז עם שיר חזק ורקדנים, ויש ילדים שצריכים כניסה קצרה ומשפחתית יותר.',
          'אני בודק מי נכנס, עם איזה שיר, האם יש חברים, רקדנים, עשן, זיקוקים קרים או אותיות שם, ומה קורה מיד אחרי הכניסה.',
          'הדבר הכי חשוב הוא שהכניסה לא תרגיש ארוכה מדי. רגע חזק של דקה עובד הרבה יותר טוב ממופע שלם שהקהל מאבד בו קשב.',
        ],
        workBullets: [
          'בחירת שיר שהחוגג או החוגגת באמת אוהבים.',
          'החלטה אם הכניסה לבד, עם חברים, רקדנים או משפחה.',
          'תזמון אפקטים כמו עשן, זיקוקים או אותיות שם.',
          'שמירה על כניסה קצרה וברורה שמתאימה לגיל.',
          'חיבור הכניסה לברכה, קליפ או פתיחת רחבה בלי עצירה.',
        ],
      },
      bar_bat_timeline: {
        title: 'תכנון לו״ז בר/בת מצווה',
        sectionTitle: 'איך בונים לו״ז לבר או בת מצווה',
        description: 'לו״ז בר/בת מצווה צריך לתת מקום לכניסה, ברכות, אוכל ורחבה שמתאימה לנוער ולמשפחה, בלי לאבד אנרגיה ובלי להעמיס על הערב.',
        carouselDescription: 'לו״ז בר מצווה או בת מצווה צריך לאזן בין החברים מהכיתה, המשפחה וההורים: כניסה, קליפ, ברכות, אוכל, משחקי רחבה וריקודים. במדריך תראו איך לפתוח רחבה מספיק מוקדם לנוער, איך לקצר נאומים וקטעי תוכן, ואיך לתאם הפעלות עם הדיג׳יי בלי להפוך את הערב לרשימת משימות.',
        imageAlt: 'תכנון לוח זמנים לבר או בת מצווה',
        intro: 'האתגר בבר/בת מצווה הוא לשמור על הילדים בעניינים בלי לאבד את המשפחה. לו״ז נכון עושה את האיזון.',
        bullets: ['קבעו מתי הכניסה, הברכות, הקליפ והאוכל.', 'השאירו רחבה פעילה מוקדם יחסית בשביל הנוער.', 'תאמו הפעלות או משחקים עם הדיג׳יי.', 'הימנעו מרצף ארוך מדי של נאומים.'],
        cta: 'לו״ז נכון לבר/בת מצווה שומר על אנרגיה ומתאים לכל הגילים.',
        trustParagraphs: [
          'בבר/בת מצווה הקהל מתחלק מהר: הילדים רוצים קצב, ההורים רוצים אירוע מכובד, והמשפחה המבוגרת צריכה להבין מה קורה. לו״ז טוב מחבר בין כולם.',
          'אם מושכים יותר מדי ברכות וקליפים לפני הרחבה, הנוער מאבד עניין. מצד שני, אם פותחים מסיבה מהר מדי, המשפחה מרגישה שלא היה מספיק מקום לרגעים החשובים.',
          'אני בונה את הסדר כך שהכניסה, האוכל, הברכות, המשחקים והריקודים יקבלו מקום, אבל בלי להפוך את הערב לרשימת משימות.',
        ],
        workBullets: [
          'קביעת סדר כניסה, קליפ, ברכות, אוכל ורחבה.',
          'פתיחת רחבה מוקדמת מספיק כדי לשמור את הנוער פעיל.',
          'תיאום משחקים, הפעלות ורגעי הפתעה עם הדיג׳יי.',
          'קיצור נאומים וקטעי תוכן כדי לא לאבד קשב.',
          'שמירה על איזון בין ילדים, הורים ומשפחה מבוגרת.',
        ],
      },
      bar_bat_attractions: {
        title: 'אטרקציות לבר/בת מצווה',
        sectionTitle: 'איך לבחור אטרקציות לבר או בת מצווה',
        description: 'אטרקציות לבר/בת מצווה צריכות להתאים לחוגגים, לחברים ולמשפחה בלי להשתלט על האירוע. הבחירה צריכה להיות צעירה, מצטלמת טוב, בטוחה, וקלה להפעלה בזמן שהרחבה ממשיכה לעבוד.',
        carouselDescription: 'אטרקציות לבר מצווה או בת מצווה צריכות להתאים לגיל, לחברים ולאופי של החוגגים: וידאו AI, עמדות צילום, רקדנים, משחקי רחבה, זוהרים, בלונים, אותיות שם, עשן או זיקוקים קרים. המדריך מסביר איך לבחור אטרקציה צעירה ומצטלמת, איך לתזמן אותה עם הדיג׳יי, ואיך לא להעמיס על הרחבה.',
        imageAlt: 'אטרקציות לבר או בת מצווה',
        intro: 'בבר או בת מצווה אפשר לשלב עמדות צילום, וידאו AI, רקדנים, משחקי רחבה, בלונים, זוהרים, מתנפחים מעוצבים, אותיות שם, לייזרים, תותחי עשן או כניסה עם זיקוקים קרים. חשוב לבחור אטרקציות שהילדים באמת יתחברו אליהן ולא רק מה שנראה יפה בקטלוג.',
        bullets: ['בחרו אטרקציה שהילד או הילדה באמת אוהבים ושמתאימה לאופי שלהם, בין אם זו כניסה דרמטית, משחק רחבה או וידאו AI מצחיק.', 'בדקו שהיא מתאימה לגיל החברים ולא מביכה את החוגגים מול הכיתה.', 'תאמו זמן הפעלה שלא שובר את הרחבה: עדיף להכניס אטרקציה אחרי כניסה, אחרי אוכל או לפני שיא מוזיקלי.', 'עדיף אטרקציה אחת חזקה או שתיים מדויקות מאשר הרבה דברים מפוזרים שגורמים לילדים לברוח מהרחבה.'],
        cta: 'אטרקציה נכונה הופכת את הבר או בת המצווה לאישי יותר בלי לפגוע בקצב של האירוע.',
        trustParagraphs: [
          'באירועי בר/בת מצווה אטרקציה חייבת לעבור קודם דרך השאלה: האם הילד או הילדה ירגישו עם זה טוב? מה שנראה מרשים להורים יכול לפעמים להביך את החוגגים מול החברים.',
          'אני מעדיף אטרקציות קצרות, מצטלמות וקלות להפעלה: כניסה חזקה, וידאו AI, אותיות שם, משחק רחבה או אפקט שמגיע בדיוק על שיא מוזיקלי.',
          'צריך להיזהר לא להפוך את האירוע להפעלות בלי רחבה. הילדים באים לזוז, לצחוק ולהרגיש חלק, לא לעמוד בתור לכל עמדה.',
        ],
        workBullets: [
          'בחירת אטרקציה שמתאימה לאופי החוגגים ולגיל החברים.',
          'תזמון כניסה, וידאו AI, משחקי רחבה, אותיות או אפקטים.',
          'בדיקה שהאטרקציה לא מביכה ולא ארוכה מדי.',
          'שמירה על רחבה פעילה בלי יותר מדי עצירות.',
          'תיאום בטיחות, מקום וחשמל מול האולם.',
        ],
      },
      bar_bat_musicians: {
        title: 'נגנים לבר/בת מצווה',
        sectionTitle: 'מתי לשלב נגנים בבר או בת מצווה',
        description: 'נגנים לבר מצווה או בת מצווה יכולים לשדרג כניסה, קבלת פנים או פתיחת רחבה קצרה: סקסופון לבר מצווה, כנרית לבר מצווה, מתופפים, דרבוקות, גיטרה, זמרים, קלידים או להקה צעירה.',
        carouselDescription: 'נגנים לבר מצווה או בת מצווה צריכים להיות קצרים ומתאימים לגיל של החוגגים. סקסופון לבר מצווה יכול לפתוח רחבה, כנרית לבר מצווה יכולה להתאים לרגע משפחתי, ומתופפים או דרבוקות עובדים טוב בכניסה קצרה. גיטרה, קלידים, זמרים או להקה קצרה מתאימים רק אם הם לא הופכים את האירוע למבוגר מדי.',
        imageAlt: 'נגנים באירוע בר או בת מצווה',
        intro: 'בבר או בת מצווה הנגן חייב להתאים לגיל ולאופי של החוגגים. סקסופון לבר מצווה יכול להרים פתיחת רחבה, כנרית לבר מצווה יכולה להתאים לרגע משפחתי, מתופפים או דרבוקות עובדים טוב בכניסה קצרה, וגיטרה, קלידים, זמרים או להקה יכולים להתאים לקבלת פנים אם הם לא הופכים את האירוע למבוגר מדי.',
        bullets: ['בחרו כלי נגינה שמתאים לאופי החוגגים: סקסופון למסיבה, כנרית לרגע מרגש, דרבוקות או מתופפים לפתיחה שמחה, גיטרה או קלידים לקבלת פנים.', 'שלבו נגנים ברגע קצר ומדויק, לא כמופע ארוך שמרחיק את הילדים מהרחבה.', 'תאמו מראש עם הדיג׳יי את השירים, הסולמות, המיקרופונים, הקלידים והסאונד.', 'ודאו שהנגנים לא מחליפים את הרחבה אלא מחזקים את הכניסה, הברכה או פתיחת הריקודים.'],
        cta: 'שילוב נגנים נכון בבר או בת מצווה מוסיף חגיגיות בלי להפוך את האירוע לכבד או מביך.',
        trustParagraphs: [
          'נגנים בבר/בת מצווה צריכים להיות מדויקים מאוד. קהל של ילדים ונוער לא תמיד מתחבר להופעה ארוכה, אבל כן מגיב טוב לרגע קצר שמרים כניסה, ברכה או פתיחת רחבה.',
          'סקסופון, כנרית, מתופפים, דרבוקות, גיטרה, קלידים, זמרים או להקה קצרה יכולים לעבוד יפה, בתנאי שהם משתלבים עם השירים שהילדים מכירים ולא הופכים את האירוע למבוגר מדי.',
          'התפקיד שלי הוא לחבר בין הנגן, הדיג׳יי והקהל כך שהרגע ירגיש חגיגי אבל עדיין צעיר, קצר וברור.',
        ],
        workBullets: [
          'בחירת כלי נגינה שמתאים לגיל ולאופי האירוע: סקסופון לבר מצווה, כנרית, מתופפים, דרבוקות, גיטרה, קלידים, זמרים או להקה.',
          'שילוב הנגן בכניסה, קבלת פנים, ברכה משפחתית או פתיחת רחבה.',
          'תיאום שירים, סולמות, מיקרופונים וסאונד מול הדיג׳יי.',
          'שמירה על קטע קצר כדי לא לאבד את הנוער.',
          'מעבר מהנגן לסט ריקודים בצורה חלקה.',
        ],
      },
      bar_bat_music: {
        title: 'בחירת מוזיקה לבר/בת מצווה',
        sectionTitle: 'איך לבחור מוזיקה לבר או בת מצווה',
        description: 'מוזיקה לבר/בת מצווה צריכה לדבר גם לחברים מהכיתה וגם למשפחה. השילוב הנכון מחזיק את הנוער ברחבה בלי להשאיר את המבוגרים מחוץ לאירוע.',
        carouselDescription: 'בחירת מוזיקה לבר מצווה או בת מצווה צריכה לדבר גם לילדים ולנוער וגם למשפחה. המדריך מסביר איך לשלב להיטי פופ, היפ הופ, מזרחית, לטינית, טראנס, טכנו ושירי טיקטוק שמתאימים לגיל, יחד עם נוסטלגיות, ישראלי או מוזיקה דתית למשפחה, בלי להשאיר אף קהל מחוץ לרחבה.',
        imageAlt: 'בחירת מוזיקה לבר מצווה או בת מצווה',
        intro: 'בבר או בת מצווה יש קהל מאוד מגוון: ילדים ונוער שרוצים להיטים, הורים שרוצים מוזיקה נעימה, משפחה מבוגרת שרוצה להרגיש שייכת, ולעיתים גם קהל דתי או מסורתי. לכן לא בוחרים רק “מה שהילדים שומעים”, אלא בונים ערב עם שכבות.',
        bullets: ['שאלו את החוגג או החוגגת איזה זמרים, להקות וסגנונות הם באמת אוהבים: פופ, היפ הופ, מזרחית, לטינית, טראנס, טכנו או שירי טיקטוק שמתאימים לגיל.', 'בדקו מה המשפחה אוהבת לשמוע: נוסטלגיות, ישראלי, להקות, מוזיקה דתית, חסידית או מזרחית שתפתח גם את המבוגרים.', 'שלבו בין להיטים לנוער לבין רגעים משפחתיים: כניסה, ברכות, שיר מוקלט, משחקי רחבה וסט ריקודים שמתאים לכל הגילים.', 'הכינו רשימת שירים שלא רוצים באירוע, במיוחד אם יש מילים לא מתאימות לגיל או לקהל דתי.'],
        cta: 'בחירת מוזיקה לבר/בת מצווה טובה נותנת לילדים להרגיש במרכז, אבל שומרת על אירוע משפחתי שמח ומכבד.',
        trustParagraphs: [
          'בבר/בת מצווה הדיג׳יי צריך לדבר בשתי שפות: השפה של החברים מהכיתה והשפה של המשפחה. אם מנגנים רק להיטים לנוער, המבוגרים יוצאים החוצה. אם מנגנים רק למשפחה, הילדים נעלמים.',
          'אני בודק עם החוגגים מה הם באמת אוהבים, אבל גם מסנן שירים שלא מתאימים לגיל, למילים או לקהל דתי/מסורתי אם יש כזה.',
          'המטרה היא לבנות ערב שבו הילד או הילדה מרגישים במרכז, והמשפחה עדיין מרגישה שזה אירוע מכבד ושמח.',
        ],
        workBullets: [
          'רשימת סגנונות שהחוגגים אוהבים באמת.',
          'בדיקת שירים לא מתאימים מבחינת מילים, גיל או קהל דתי.',
          'שילוב פופ, היפ הופ, מזרחית, לטינית, טראנס, טכנו ונוסטלגיות לפי הקהל.',
          'הכנסת רגעים משפחתיים בין סטים צעירים יותר.',
          'קריאת רחבה שמחזיקה גם ילדים וגם מבוגרים.',
        ],
      },
      event_music: {
        title: 'בחירת מוזיקה לאירוע',
        sectionTitle: 'איך לבחור מוזיקה לאירוע',
        description: 'כל אירוע צריך קו מוזיקלי משלו. כדי לבחור נכון צריך להבין מי הקהל, מה מטרת הערב, איזה סגנונות אוהבים ומה יגרום לאנשים להישאר באווירה.',
        carouselDescription: 'בחירת מוזיקה לאירוע מתחילה מהקהל ומהאווירה שרוצים ליצור. מדריך מוזיקה לאירוע מסביר איך לבנות קו מוזיקלי נכון לקבלת פנים, פתיחה, רגעי תוכן ורחבת ריקודים, איך לבחור שירים שמתאימים לגיל האורחים, ואיך לשלב מזרחית, ישראלי, לטיני, היפ הופ, נוסטלגיות, טכנו או טראנס בלי שהערב ירגיש מפוזר. תכנון נכון עם די ג׳יי לאירוע עוזר לשמור על אנרגיה, מעברים חלקים ורחבה שמגיבה לקהל בזמן אמת.',
        imageAlt: 'דיג׳יי מתכנן מוזיקה לאירוע',
        intro: 'באירוע כללי או עסקי אין תבנית אחת. לפעמים צריך מוזיקת רקע אלגנטית, לפעמים קבלת פנים חמה, ולפעמים מסיבה מלאה. הבחירה מתחילה בשאלה מי מגיע: עובדים, לקוחות, משפחה, צעירים, מבוגרים, קהל דתי או קהל מעורב.',
        bullets: ['הגדירו מראש את סוג הקהל והאווירה הרצויה: יוקרתי, קליל, משפחתי, עסקי, שמח או מסיבתי.', 'רשמו סגנונות שיכולים להתאים: מוזיקה מזרחית, ישראלית, לטינית, היפ הופ, נוסטלגיות, טראנס, טכנו, מוזיקה דתית או פלייליסט בינלאומי.', 'בחרו זמרים ולהקות שאתם מתחברים אליהם, אבל השאירו לדיג׳יי מקום לקרוא את הקהל בזמן אמת.', 'הכינו רשימת שירים שלא תרצו לשמוע כדי לשמור על גבולות ברורים בלי לחסום את הזרימה.'],
        cta: 'בין אם זה אירוע פרטי או עסקי, תכנון מוזיקלי נכון עושה את ההבדל בין רקע נעים לערב שאנשים זוכרים.',
        trustParagraphs: [
          'באירוע כללי אין “נוסחה”. אירוע חברה, יום הולדת, מסיבת עובדים, השקה או אירוע משפחתי קטן צריכים מוזיקה אחרת לגמרי. לכן מתחילים מהמטרה של הערב, לא מהפלייליסט.',
          'אני בודק מי מגיע, כמה הקהל מכיר אחד את השני, האם צריך מוזיקה שתאפשר שיחה, מתי נכון להרים קצב, והאם בכלל מתוכננת רחבה או רק אווירה.',
          'באירועים כאלה חשוב במיוחד לא להגזים. לפעמים מוזיקה מדויקת ברקע עושה עבודה טובה יותר מסט אגרסיבי מדי.',
        ],
        workBullets: [
          'הגדרת סוג האירוע: עסקי, משפחתי, פרטי, השקה או מסיבה.',
          'הבנת גיל הקהל, הקשר בין האורחים ורמת האנרגיה הרצויה.',
          'בחירת סגנונות: מזרחית, ישראלי, לטיני, היפ הופ, נוסטלגיות, טכנו או טראנס.',
          'הפרדה בין מוזיקת רקע, רגעי תוכן ורחבת ריקודים.',
          'רשימת שירים לא רצויים כדי לשמור על גבולות ברורים.',
        ],
      },
      event_entrance: {
        title: 'כניסה לאירוע',
        sectionTitle: 'איך מתכננים כניסה לאירוע',
        description: 'כניסה לאירוע נותנת פתיחה ברורה, חגיגית ומדויקת לאווירה של הערב, עם שיר נכון, תזמון קצר ותיאום בין התקליטן, התאורה וההכרזה.',
        carouselDescription: 'כניסה לאירוע זה הרגע שבו הקהל מבין שהערב באמת מתחיל. מדריך כניסה לאירוע מסביר איך לבחור שיר פתיחה נכון, איך לתאם הכרזה, תאורה, מיקרופון ותזמון מול הדיג׳יי, ואיך להחליט מראש מי נכנס, מי מדבר ומה קורה מיד אחרי הכניסה. כשהפתיחה מתוכננת נכון, המעבר לקבלת פנים, ברכה, תוכן, אוכל או רחבת ריקודים מרגיש טבעי וברור ולא כמו הכרזה שנזרקה ברגע האחרון.',
        imageAlt: 'כניסה חגיגית לאירוע',
        intro: 'כניסה לאירוע צריכה להרגיש כמו פתיחה טבעית של הערב, לא כמו קטע נפרד. השיר, ההכרזה והתאורה צריכים לסמן לקהל מה מתחיל עכשיו ומה קורה מיד אחר כך.',
        bullets: ['בחרו שיר פתיחה שמתאים לאופי האירוע ולקהל.', 'החליטו מראש מי נכנס, מי מכריז, איפה עומדים בעלי השמחה ומה קורה מיד אחרי הכניסה.', 'תאמו מול הדיג׳יי את ההכרזה, התאורה, המיקרופון והווליום כדי שהפתיחה תהיה נקייה וברורה.', 'חברו את הכניסה להמשך הערב: ברכה, מצגת, אוכל, תוכן קצר או פתיחת רחבת ריקודים.'],
        cta: 'כניסה טובה יוצרת התחלה ברורה ומכניסה את הקהל לאווירה.',
        trustParagraphs: [
          'כניסה לאירוע צריכה להיות פשוטה וברורה. לפעמים זו כניסה של בעלי השמחה, ולפעמים הכרזה שמסמנת שהאירוע עובר מקבלת פנים לתוכן או לרחבה.',
          'אם הכניסה לא מתוכננת, היא יכולה להרגיש כמו הכרזה מקרית. עם שיר נכון, תאורה נכונה ותזמון קצר, היא הופכת לרגע שמסדר את הקהל.',
          'אני בודק מי נכנס, מה נאמר במיקרופון, האם יש לוגו, תאורה או אפקט, ומה קורה מיד אחרי הכניסה.',
        ],
        workBullets: [
          'בחירת שיר פתיחה שמתאים לאופי האירוע.',
          'קביעת מי נכנס, מי מכריז ומה סדר הפעולות.',
          'תיאום תאורה, מיקרופון ואפקטים אם יש.',
          'שמירה על כניסה קצרה ומדויקת.',
          'חיבור הכניסה להמשך טבעי: ברכה, תוכן, אוכל או רחבה.',
        ],
      },
      event_attractions: {
        title: 'אטרקציות לאירוע',
        sectionTitle: 'איך לבחור אטרקציות לאירוע',
        description: 'אטרקציות לאירוע צריכות להתאים לקהל, למקום ולמטרה של הערב. כשהן מתוזמנות נכון הן יוצרות רושם, תמונות ורגעי שיא בלי לנתק את הקהל מהאווירה.',
        carouselDescription: 'אטרקציות לאירוע צריכות להוסיף רגעים, תמונות ואנרגיה בלי להשתלט על הערב. מדריך אטרקציות לאירוע עוזר לבחור בין זיקוקים קרים, עשן, לייזרים, לוגו מואר, וידאו AI, עמדות צילום, בלונים, צלם מגנטים, בר קוקטיילים או אפטר פארטי, ולבדוק מה באמת מתאים לקהל, למקום וללו״ז. כשמתאמים מראש את האטרקציות עם הדיג׳יי, התאורה והאולם, כל אפקט נכנס בזמן נכון ומחזק את האווירה במקום לעצור אותה.',
        imageAlt: 'אטרקציות באירוע פרטי או עסקי',
        intro: 'אפשר לשלב זיקוקים קרים לכניסה, תותחי עשן, לייזרים, אותיות או לוגו מואר, מתנפחים מעוצבים, וידאו AI, עמדות צילום, בלונים מתפוצצים לרגע שיא ואפטר פארטי לפי סגנון מוזיקלי. באירועים מסוימים הדיג׳יי יכול לרדת לרחבה, להחליף אנרגיה וליצור תחושה של מסיבה חיה יותר.',
        bullets: ['התאימו את האטרקציה לקהל: אירוע עסקי צריך רושם נקי ומדויק, אירוע פרטי יכול להרשות לעצמו יותר צבע, הפתעות ורחבה משוחררת.', 'בדקו חשמל, מקום, גובה תקרה, אישורי אולם וזמן הקמה, במיוחד בזיקוקים קרים, עשן, לייזרים ומתנפחים.', 'תאמו תזמון עם הדיג׳יי כדי שהאפקט יגיע על דרופ, כניסה, הכרזה, סלואו או מעבר לאפטר פארטי.', 'ודאו שהאטרקציה תומכת בזרימת האירוע ולא הופכת להפסקה טכנית שמורידה את האנרגיה.'],
        cta: 'אטרקציות טובות מוסיפות ערך כשהן מתוזמנות נכון ומחוברות למוזיקה, לקהל ולמטרה של הערב.',
        trustParagraphs: [
          'באירוע כללי, האטרקציה חייבת להתאים למטרה. באירוע עסקי היא צריכה להיראות נקייה ומקצועית; באירוע פרטי אפשר ללכת על משהו צבעוני ומשוחרר יותר.',
          'אני בודק האם האטרקציה באמת תוסיף לערב או רק תיצור עומס. לייזרים, עשן, וידאו AI, לוגו מואר או אפטר פארטי יכולים לעבוד מצוין, אבל רק כשהם נכנסים בזמן הנכון.',
          'הכי חשוב שהקהל לא ירגיש שעוצרים את האירוע בשביל “להפעיל משהו”. האטרקציה צריכה להרגיש חלק מהמוזיקה ומהרגע.',
        ],
        workBullets: [
          'התאמת האטרקציה לקהל עסקי, פרטי, משפחתי או צעיר.',
          'בדיקת חשמל, גובה, בטיחות, מקום וזמן הקמה.',
          'תזמון אפקטים על כניסה, דרופ, הכרזה או אפטר פארטי.',
          'בחירת אטרקציות שלא חוסמות צילום או רחבה.',
          'שילוב הדיג׳יי ברחבה אם זה מתאים לאופי המסיבה.',
        ],
      },
      event_musicians: {
        title: 'נגנים לאירוע',
        sectionTitle: 'שילוב נגנים באירוע',
        description: 'נגנים לאירוע מוסיפים שכבה חיה לקבלת פנים, לטקס קצר או לרגע שיא: כנר לאירוע, כנרית לאירוע, סקסופון לאירוע, בוזוקי, גיטרה, דרבוקות, מתופפים, זמרים, קלידים או להקה לאירוע.',
        carouselDescription: 'נגנים לאירוע יכולים להוסיף שכבה חיה לקבלת פנים, פתיחה, רגע משפחתי או רחבת ריקודים, אבל רק כשהם משתלבים נכון עם הדיג׳יי. מדריך נגנים לאירוע מסביר איך לבחור כנר לאירוע, כנרית לאירוע, סקסופון לאירוע, בוזוקי, גיטרה, דרבוקות, מתופפים, זמרים, קלידים או להקה לאירוע, ואיך לתאם רפרטואר, חיבורים, ווליום ונקודות כניסה. המטרה היא שהנגנים יחזקו את האווירה ולא יתחרו במוזיקה המרכזית.',
        imageAlt: 'נגנים לאירוע עם דיג׳יי',
        intro: 'באירוע פרטי, עסקי או משפחתי אפשר לשלב כנר לאירוע, כנרית, סקסופון, בוזוקי, גיטרה, דרבוקות, מתופפים, זמרים, קלידים או להקה. השאלה היא לא רק איזה נגן נשמע טוב, אלא איפה הוא נכנס: קבלת פנים, טקס קצר, ברכה, הרמת כוסית, פתיחת רחבה או רגע שיא.',
        bullets: ['בחרו נגנים לפי האווירה הרצויה: כנר או כנרית לאירוע אלגנטי, סקסופון לקבלת פנים, בוזוקי וגיטרה לאווירה ים תיכונית, דרבוקות ומתופפים לפתיחת קצב.', 'תאמו רפרטואר, סולמות, נקודות כניסה וסיומות מראש מול הדיג׳יי.', 'בדקו מיקרופונים, DI, מוניטור, חשמל, קלידים וחיבורים מול המקום.', 'שלבו זמרים או להקה לאירוע רק כשיש להם מקום ברור בלו״ז ולא כשהרחבה כבר צריכה להישאר פתוחה.'],
        cta: 'שילוב נכון של נגנים לאירוע נותן נוכחות חיה ומרשימה בלי לפגוע בקצב של הערב.',
        trustParagraphs: [
          'נגנים באירוע כללי צריכים להתאים לאופי הערב: כנר לאירוע עסקי יכול לתת אלגנטיות, סקסופון יכול להרים קבלת פנים או רחבה, בוזוקי וגיטרה נותנים צבע ים תיכוני, ודרבוקות או מתופפים יכולים לפתוח מסיבה. לא כל נגן מתאים לכל אירוע.',
          'אני בודק אם הנגן אמור להיות ברקע, להוביל רגע שיא או להצטרף לסט הדיג׳יי. ההגדרה הזאת קובעת את הרפרטואר, הסאונד, המיקרופונים, הקלידים, מיקום הלהקה והזמן הנכון.',
          'כשהנגנים משתלבים נכון, הם מוסיפים חיים ונוכחות בלי להתחרות במוזיקה המרכזית ובלי לעצור את הרחבה.',
        ],
        workBullets: [
          'בחירת נגן לפי אווירה: כנר לאירוע, כנרית, סקסופון, בוזוקי, גיטרה, דרבוקות, מתופפים, זמרים, קלידים או להקה לאירוע.',
          'תיאום רפרטואר, סולמות ונקודות כניסה מראש.',
          'בדיקת חיבורים, מיקרופונים, מוניטור, קלידים וסאונד מול המקום.',
          'קביעת משך הופעה שמתאים לקהל ולא פוגע ברחבה.',
          'מעבר נקי בין נגינה חיה לסט הדיג׳יי.',
        ],
      },
      event_music_timeline: {
        title: 'תכנון לו״ז לאירוע',
        sectionTitle: 'איך בונים לו״ז לאירוע',
        description: 'לו״ז מסודר עוזר לאירוע לזרום נכון: קבלת פנים, ברכות, רגעי שיא, אוכל ורחבה, עם מעברים ברורים שמונעים עצירות ונפילות אנרגיה.',
        carouselDescription: 'תכנון לו״ז לאירוע הוא מה שמחזיק את הערב מסודר מהרגע הראשון ועד סוף הרחבה. מדריך לו״ז לאירוע מסביר איך לחבר בין קבלת פנים, פתיחה, ברכות, מצגת, קליפ, אוכל וריקודים, איך להשאיר מרווחים לשינויים בזמן אמת, ואיך לתאם בין האולם, הצלמים, המנחה והדיג׳יי. לו״ז נכון מאפשר למוזיקה להיכנס בכל רגע בזמן, מונע עומס ועוזר לאורחים להרגיש שהאירוע מתקדם בצורה טבעית.',
        imageAlt: 'תכנון לוח זמנים לאירוע',
        intro: 'גם האירוע הכי יפה יכול להרגיש מפוזר בלי תזמון נכון. כשיש לו״ז ברור, כל ספק יודע מתי להיכנס, והדיג׳יי יכול לשמור על קצב טבעי לאורך הערב.',
        bullets: ['חלקו את האירוע לשלבים: קבלת פנים, פתיחה, תוכן, אוכל וריקודים.', 'הגדירו מראש רגעי שיא כמו כניסה, ברכה, קליפ או הרמת כוסית.', 'השאירו מרווחים קצרים לשינויים בזמן אמת.', 'תאמו את הלו״ז עם האולם, הצלמים, המנחה והדיג׳יי.'],
        cta: 'לו״ז טוב מוריד לחץ ביום האירוע. אפשר לבנות אותו יחד לפי המקום, הקהל, הספקים והתוכן.',
        trustParagraphs: [
          'באירוע כללי הלו״ז הוא מה שמונע בלגן. אם אין סדר ברור, לא יודעים מתי לדבר, מתי להגיש אוכל, מתי להפעיל קליפ ומתי לפתוח רחבה.',
          'אני מתכנן את הלו״ז לפי סוג האירוע: אירוע עסקי צריך דיוק ותוכן מסודר, אירוע פרטי צריך יותר גמישות, ואירוע מסיבתי צריך להגיע מהר יותר לאנרגיה.',
          'הדיג׳יי יכול לעזור מאוד בניהול המעברים, אבל רק אם ברור מראש מה אמור לקרות בכל שלב.',
        ],
        workBullets: [
          'חלוקת הערב לקבלת פנים, פתיחה, תוכן, אוכל וריקודים.',
          'סימון רגעי שיא כמו כניסה, ברכה, קליפ או הרמת כוסית.',
          'השארת מרווחים קטנים לשינויים בלי לפרק את הלו״ז.',
          'תיאום מול אולם, צלמים, מנחה, ספקים ודיג׳יי.',
          'התאמת הקצב לאירוע עסקי, פרטי או מסיבתי.',
        ],
      },
    },
  },


  menu: {
    sections: [
      { id: 'home', label: 'בית' },
      { id: 'story', label: 'הסיפור שלי' },
      { id: 'gallery', label: 'גלריה' },
      { id: 'contact', label: 'דברו איתי' },
      { id: 'reviews', label: 'ביקורות' },
      { id: 'planning', label: 'ארגון אירוע' },
      { id: 'info', label: 'מידע נוסף' },
    ],
  },
    // ─────────────────────────────────────────────────────────────
  // SEO FAQ — Wedding
  // ─────────────────────────────────────────────────────────────

  seo: {
    faq: {
      wedding: [
        {
          q: `מה כולל שירות תקליטן לחתונה {city}?`,
          a: `השירות כולל היכרות אישית ובניית פסקול מותאם במיוחד עבורכם, ליווי מקצועי לאורך כל הדרך, קריאת קהל חדה, מיקסים מדויקים ושילוב סגנונות, סאונד ואנרגיה שמבטיחה חתונה שמחה מהרגע הראשון ועד השיר האחרון.`,
        },
        {
          q: `כמה עולה די ג׳יי לחתונה {city}?`,
          a: `{city} טווח המחירים נע לרוב בין 4,000 ל־9,000 ₪, בהתאם לגודל החתונה, התאריך והציוד.`,
        },
        {
          q: `איך לבחור דיג׳יי לחתונה {city}?`,
          a: `חשוב לבחור דיג׳יי עם ניסיון מוכח בחתונות, יכולת קריאת קהל גבוהה וחיבור אישי לזוג. מומלץ לבדוק המלצות, לראות סרטונים מאירועים אמיתיים ולהרגיש שיש מי שמבין את הסגנון שלכם ויודע להוביל את הערב בצורה מקצועית.`,
        },
        {
          q: `האם תקליטן {city} מספק גם ציוד תאורה?`,
          a: `ברוב האולמות קיימת תאורה בסיסית לרחבת הריקודים. למי שמעוניין, ניתן לשלב תאורת במה ותאורות עיצוב מתקדמות בהתאמה אישית לאופי האירוע. אני עובד עם ספקים מובילים בתחום, עם מגוון רחב של אפשרויות תאורה ועיצובי במה לבחירת הזוג, כאשר המחיר משתנה בהתאם לבחירה.`,
        },
        {
          q: `האם אפשר לשלב נגנים חיים בחתונה {city}?`,
          a: `בוודאי, ניתן לשלב נגנים חיים כמו סקסופוניסט, כנרית, דרבוקן או בוזוקי ליצירת אווירה ייחודית ומרגשת.`,
        },
        {
          q: `כמה זמן מנגן דיג׳יי בחתונה?`,
          a: `משך הנגינה נקבע מראש בהתאם ללוח הזמנים של האירוע ויכול להתחיל מכשעתיים ועד ללא הגבלת זמן, בהתאם לבחירת הזוג ולמהלך האירוע.`,
        },
        {
          q: `האם די ג׳יי מקומי {city} מכיר את האולמות?`,
          a: `ברוב המקרים כן. היכרות עם אולמות וגני אירועים באזור מאפשרת עבודה חלקה מול צוות המקום, התאמה מדויקת של הסאונד והתאורה למבנה האולם והיערכות נכונה ללוח הזמנים של האירוע – מה שתורם לזרימה טובה ולחוויה מקצועית יותר לאורך הערב.`,
        },
        {
          q: `מה כוללות חבילות תקליטן לחתונה {city}?`,
          a: `חבילת הבסיס כוללת הגעה עם ציוד הדיג׳יי המקצועי והנגינה לאורך האירוע. מעבר לכך ניתן לשדרג ולבנות חבילה בהתאמה אישית הכוללת עמדות דיג׳יי מעוצבות, אפטר פארטי, חבילות סלואו ופרימיום, אטרקציות מיוחדות, נגנים חיים ותוספות שונות בהתאם לסגנון האירוע ולבחירת הזוג.`,
        },
        {
          q: `האם יש גיבוי לציוד?`,
          a: `כן, תקליטן מקצועי תמיד מגיע עם ציוד חלופי ותכנית חירום.`,
        },
        {
          q: `איך בוחרים שירים לחופה?`,
          a: `בחירת שירי החופה נעשית יחד עם הזוג ובהתאמה אישית. בדרך כלל בוחרים שיר לכניסת החתן, שיר לכניסת הכלה ושיר לשבירת הכוס, ולעיתים משלבים גם קטעים מיוחדים נוספים. התהליך נעשה בתיאום מלא ותוך ירידה לפרטים הקטנים כדי ליצור רגע מרגש ומדויק.`,
        },
        {
          q: `כמה זמן מראש צריך לשריין תקליטן לחתונה {city}?`,
          a: `לפחות חצי שנה מראש, ובקיץ מומלץ אפילו שנה מראש.`,
        },
        {
          q: `האם יש אפשרות לבחירת פלייליסט מלא?`,
          a: `בוודאי. ניתן להעביר רשימת שירים מלאה, רשימת שירים מועדפים, שירים שלא תרצו שיתנגנו או רק כיוונים כלליים לסגנון המוזיקה.`,
        },
        {
          q: `מה האטרקציות הפופולריות לחתונה {city}?`,
          a: `האטרקציות הפופולריות כוללות זיקוקים קרים, עשן כבד, בלונים מתפוצצים, בועות סבון, תאורת במה, נגנים חיים, קונפטי ועוד.`,
        },
      ],
      henna: [
        {
          q: `מה כולל שירות תקליטן לחינה {city}?`,
          a: `השירות כולל היכרות אישית ובניית פסקול מותאם במיוחד עבורכם, ליווי מקצועי לאורך כל הדרך, קריאת קהל חדה, מיקסים מדויקים ושילוב סגנונות, סאונד ואנרגיה שמבטיחה חינה שמחה מהרגע הראשון ועד השיר האחרון.`,
        },
        {
          q: `אילו סוגי חינות קיימות?`,
          a: `יש מגוון סגנונות כמו חינה מרוקאית, תימנית, פרסית, טוניסאית ועוד. בפועל אפשר גם לשלב בין סגנונות, בהתאם למשפחה, למסורת ולווייב שאתם רוצים ליצור.`,
        },
        {
          q: `איך מתכננים את הכניסות של הארוס והארוסה בחינה {city}?`,
          a: `מתכננים מראש את סדר הכניסות, השירים לכל כניסה ואת הקצב של המעברים, כדי ליצור רגע מרגש ומרשים. אני מלווה אתכם בתיאום השירים והטיימינג מול המקום והמשפחה לפי מה שמתאים לכם.`,
        },
        {
          q: `האם אפשר לתכנן טקס מריחת חינה בצורה מסודרת?`,
          a: `כן. מתאמים מראש את סדר הטקס, המוזיקה לרגעים המרכזיים והמעבר לרחבה. המטרה היא לשמור על זרימה טובה בין הטקס לבין המסיבה, בלי “נפילות” באנרגיה.`,
        },
        {
          q: `איך משלבים את טקס הענקת הזהב בחינה?`,
          a: `בדרך כלל בוחרים שיר/ים מתאימים, מתזמנים את הרגע מול המשפחה והצלמים, ושומרים על רצף מכבד ומרגש. הכול נקבע מראש לפי אופי המשפחה והטקס שאתם רוצים.`,
        },
        {
          q: `האם אפשר לשלב לבוש מסורתי ותלבושות בחינה {city}?`,
          a: `בוודאי. לרוב מתכננים מראש את החלפות הלבוש והטיימינג שלהן, כדי שזה ישתלב נכון עם הטקס, הכניסות והצילום. מומלץ לתאם גם מול האולם או המפיק כדי שהכול ירוץ חלק.`,
        },
        {
          q: `כמה עולה די ג׳יי לחינה {city}?`,
          a: `בדרך כלל טווח המחירים נע בין 2,500 ל־5,000 ₪, בהתאם לגודל החינה, התאריך, המקום והתוספות שנבחרות.`,
        },
        {
          q: `איך לבחור דיג׳יי לחינה {city}?`,
          a: `חשוב לבחור דיג׳יי שיודע לקרוא קהל, לשלב סגנונות שמתאימים לאופי החינה, ולהוביל ערב בצורה מקצועית. מומלץ לבדוק המלצות, לראות סרטונים מאירועים אמיתיים ולהרגיש שיש חיבור וגישה שמתאימה לכם.`,
        },
        {
          q: `כמה זמן מנגן תקליטן בחינה?`,
          a: `משך הנגינה נקבע מראש בהתאם ללוח הזמנים של האירוע ויכול להתחיל מכשעתיים ועד ללא הגבלת זמן, בהתאם לבחירתכם ולמהלך האירוע.`,
        },
        {
          q: `מה כוללות חבילות דיג׳יי לחינה?`,
          a: `חבילת הבסיס כוללת הגעה עם ציוד הדיג׳יי המקצועי והנגינה לאורך האירוע. מעבר לכך ניתן לשדרג בהתאמה אישית: עמדות דיג׳יי מעוצבות, אפטר פארטי, חבילות פרימיום, שילוב נגנים חיים ותוספות שונות לפי הבחירה.`,
        },
        {
          q: `האם אפשר לשלב נגנים חיים בחינה?`,
          a: `בוודאי. ניתן לשלב נגנים חיים כמו שופרות, סקסופון, כנרית או בוזוקי – בהתאם לסגנון החינה ולבחירתכם.`,
        },
        {
          q: `מה האטרקציות הפופולריות בחינה {city}?`,
          a: `האטרקציות הפופולריות כוללות זיקוקים קרים, עשן כבד, בלונים מתפוצצים, בועות סבון, אותיות, תאורת לייזר, תאורת במה, נגנים חיים, קונפטי, שופרות, צלם מגנטים, בר קוקטיילים ועוד.`,
        },
        {
          q: `האם תקליטן {city} מספק גם ציוד תאורה?`,
          a: `ברוב האולמות קיימת תאורה בסיסית לרחבה. למי שמעוניין, ניתן לשלב תאורת במה ותאורות עיצוב מתקדמות בהתאמה אישית. אני עובד עם ספקים מובילים בתחום ויש מגוון רחב של אפשרויות — המחיר משתנה בהתאם לבחירה.`,
        },
        {
          q: `איך בונים פלייליסט לחינה?`,
          a: `בונים יחד כיוונים מוזיקליים מראש: שירים שאתם אוהבים, שירים שלא תרצו שיתנגנו והעדפות סגנון. במהלך האירוע המוזיקה מותאמת גם לקהל ולרחבה בזמן אמת כדי לשמור על זרימה ואנרגיה.`,
        },
        {
          q: `האם יש אפשרות לבחירת פלייליסט מלא?`,
          a: `בוודאי. ניתן להעביר רשימת שירים מלאה, רשימת מועדפים, רשימת “לא לשים”, או רק כיוונים כלליים. זה הבסיס לבניית הערב, ובאירוע עצמו אני מתאים את המוזיקה לקהל כדי לשמור על רחבה פעילה.`,
        },
        {
          q: `איך להתאים מוזיקה לקהל מגוון בחינה?`,
          a: `התאמה לקהל מגוון נעשית דרך קריאת קהל בזמן אמת ושילוב נכון בין סגנונות, תקופות וקצבים שונים. המוזיקה נבנית בהדרגה בהתאם לאווירה כדי שכל קבוצות האורחים יתחברו וייהנו.`,
        },
        {
          q: `מה חשוב לבדוק בחוזה מול תקליטן?`,
          a: `כדאי לוודא: מה כלול במחיר, שעות עבודה, אפשרות להארכה, תנאי ביטול, מה נדרש מצד המקום (חשמל או עמדה) והאם יש גיבוי לציוד.`,
        },
        {
          q: `האם יש גיבוי לציוד?`,
          a: `כן, דיג׳יי מקצועי מגיע מוכן עם ציוד חלופי ותכנית חירום למקרה הצורך.`,
        },
      ],
      bar_bat: [
        {
          q: `מה כולל שירות תקליטן לבר מצווה או בת מצווה {city}?`,
          a: `השירות כולל היכרות אישית ובניית פסקול מותאם במיוחד עבורכם, ליווי מקצועי לאורך כל הדרך, קריאת קהל חדה, מיקסים מדויקים ושילוב סגנונות, סאונד ואנרגיה שמתאימה גם לנוער וגם למשפחה.`,
        },
        {
          q: `איך מתכננים כניסה מרשימה לחוגג/ת בבר/בת מצווה {city}?`,
          a: `מתכננים מראש שיר כניסה, טיימינג מדויק והעמדה של הקהל או המשפחה, ולעיתים משלבים גם אפקטים לפי בחירה. המטרה היא ליצור כניסה חזקה שמרימה את האנרגיה ומכניסה את כולם לאווירה.`,
        },
        {
          q: `האם אפשר לשלב ברכה או דרשה בבר/בת מצווה {city}?`,
          a: `כן. מתאמים מראש מתי זה קורה במהלך הערב, דואגים למיקרופון מתאים ולסאונד ברור, ומשלבים את זה בצורה זורמת שלא “עוצרת” את האירוע אלא משתלבת בו נכון.`,
        },
        {
          q: `איך שומרים על רחבה עם ילדים וגם מבוגרים בבר/בת מצווה?`,
          a: `באמצעות ניהול נכון של הסט: חלקים שמכוונים לנוער עם להיטים עדכניים, לצד מקטעים שמתאימים למשפחה. קריאת קהל בזמן אמת מאפשרת לשמור על זרימה ולקחת את הרחבה יחד.`,
        },
        {
          q: `איך מנהלים רחבת נוער כדי שלא תתפזר?`,
          a: `שומרים על רצף מוזיקלי נכון, מעבר חכם בין סגנונות, ועובדים במקצועיות מול האנרגיה של הקהל הצעיר. כשצריך מעלים הילוך, וכשצריך מאזנים כדי שהרחבה תישאר יציבה לאורך זמן.`,
        },
        {
          q: `האם אפשר לשלב משחקים או הפעלות כחלק מהמסיבה?`,
          a: `כן, לפי בחירה. אפשר לשלב מנחה או רקדנים או הפעלות רחבה שיתאימו לסגנון של החוגג או החוגגת ולקהל. חשוב שזה יהיה בטעם טוב ובתיאום מראש כדי לשמור על זרימה ולא להעמיס.`,
        },
        {
          q: `כמה עולה די ג׳יי לבר/בת מצווה {city}?`,
          a: `בדרך כלל טווח המחירים נע בין 2,500 ל־4,500 ₪, בהתאם לגודל האירוע, המקום והתוספות שנבחרות.`,
        },
        {
          q: `איך בוחרים דיג׳יי לבר מצווה {city}?`,
          a: `חשוב לבחור דיג׳יי שיודע לעבוד עם קהל צעיר, לקרוא רחבה בזמן אמת ולשלב בין מוזיקה עדכנית לשירים שמתאימים גם למשפחה ולאורחים.`,
        },
        {
          q: `איך בוחרים שירים לבר/בת מצווה?`,
          a: `החוגג או החוגגת בוחרים שירים אהובים וכיוונים מוזיקליים מראש. במהלך האירוע המוזיקה מותאמת גם לאווירה ברחבה ולקהל כדי לשמור על זרימה ואנרגיה.`,
        },
        {
          q: `כמה זמן מנגן תקליטן בבר/בת מצווה?`,
          a: `משך הנגינה נקבע מראש בהתאם ללוח הזמנים של האירוע ויכול להתחיל מכשעתיים ועד ללא הגבלת זמן, בהתאם לבחירה ולמהלך האירוע.`,
        },
        {
          q: `מה כוללות חבילות דיג׳יי לבר/בת מצווה?`,
          a: `חבילת הבסיס כוללת הגעה עם ציוד הדיג׳יי המקצועי והנגינה לאורך האירוע. ניתן לשדרג בהתאמה אישית עם עמדות דיג׳יי מעוצבות, אפטר פארטי, אטרקציות שונות, נגנים חיים ותוספות נוספות לפי הבחירה.`,
        },
        {
          q: `האם אפשר לשלב רקדנים או מנחים בבר/בת מצווה?`,
          a: `בוודאי. ניתן לשלב רקדנים, מנחים או הפעלות רחבה שיוצרות אינטראקציה עם הקהל ומגבירות את האנרגיה במהלך האירוע.`,
        },
        {
          q: `מה האטרקציות הפופולריות לבר/בת מצווה {city}?`,
          a: `האטרקציות הפופולריות כוללות זיקוקים קרים, עשן כבד, בלונים מתפוצצים, בועות סבון, אותיות, תאורת לייזר, תאורת במה, נגנים חיים, קונפטי, צלם מגנטים, בר קוקטיילים ועוד.`,
        },
        {
          q: `האם תקליטן {city} מספק גם ציוד תאורה?`,
          a: `ברוב האולמות קיימת תאורה בסיסית לרחבה. ניתן לשדרג לתאורת במה ועיצוב תאורה מתקדם בהתאמה אישית, בשיתוף ספקים מובילים בתחום ובהתאם לבחירה.`,
        },
        {
          q: `איך מתאימים מוזיקה לקהל מגוון בבר/בת מצווה?`,
          a: `התאמת מוזיקה לקהל מגוון נעשית באמצעות קריאת קהל בזמן אמת ושילוב נכון בין להיטים עדכניים, שירים אהובים על בני הנוער ומוזיקה שמתאימה גם למשפחה ולאורחים.`,
        },
        {
          q: `האם יש אפשרות לבחירת פלייליסט מלא?`,
          a: `בוודאי. ניתן להעביר רשימת שירים מלאה, רשימת מועדפים, רשימת לא לשים או רק כיוונים כלליים. הפלייליסט משמש בסיס, ובאירוע עצמו המוזיקה מותאמת לרחבה ולקהל.`,
        },
        {
          q: `מה חשוב לבדוק בחוזה מול תקליטן?`,
          a: `כדאי לוודא מה כלול במחיר, שעות עבודה, אפשרות להארכה, תנאי ביטול, דרישות טכניות מהמקום והאם יש גיבוי לציוד.`,
        },
        {
          q: `האם יש גיבוי לציוד?`,
          a: `כן, די ג׳יי מקצועי מגיע עם ציוד חלופי ותכנית חירום למקרה הצורך.`,
        },
        {
          q: `כמה זמן מראש כדאי להזמין תקליטן לבר מצווה?`,
          a: `מומלץ לשריין לפחות 3–6 חודשים מראש, ובתאריכים מבוקשים אפילו מוקדם יותר.`,
        },
        {
          q: `האם אפשר לשלב וידאו או מצגת בבר/בת מצווה?`,
          a: `כן, ניתן לשלב מסכים להצגת קליפים, מצגות ותמונות אישיות במהלך האירוע וכן לשלב קטעי סאונד ווידאו כחלק מהשואו.`,
        },
      ],
      event: [
        {
          q: `מה כולל שירות תקליטן לאירוע חברה או פרטי {city}?`,
          a: `השירות כולל היכרות אישית ובניית פסקול מותאם במיוחד עבורכם, ליווי מקצועי לאורך כל הדרך, קריאת קהל חדה, מיקסים מדויקים ושילוב סגנונות, סאונד ואנרגיה שמחזיקה את הערב בצורה טבעית.`,
        },
        {
          q: `כמה עולה די ג׳יי לאירוע {city}?`,
          a: `בדרך כלל טווח המחירים נע בין 2,000 ל־5,000 ₪, בהתאם לסוג האירוע, גודל האירוע, המקום והתוספות שנבחרות.`,
        },
        {
          q: `איך בוחרים דיג׳יי לאירוע?`,
          a: `חשוב לבחור דיג׳יי עם ניסיון, יכולת קריאת קהל, המלצות מאירועים אמיתיים וחיבור לסגנון המוזיקלי שמתאים לאופי האירוע.`,
        },
        {
          q: `כמה זמן מנגן תקליטן באירוע?`,
          a: `משך הנגינה נקבע מראש בהתאם ללוח הזמנים של האירוע ויכול להתחיל מכשעתיים ועד ללא הגבלת זמן, בהתאם לבחירה ולמהלך האירוע.`,
        },
        {
          q: `מה כוללות חבילות די ג׳יי לאירועים?`,
          a: `חבילת הבסיס כוללת הגעה עם ציוד הדיג׳יי המקצועי והנגינה לאורך האירוע. ניתן לשדרג בהתאמה אישית עם עמדות דיג׳יי מעוצבות, אפטר פארטי, אטרקציות שונות, נגנים חיים ותוספות נוספות לפי הבחירה.`,
        },
        {
          q: `האם די ג׳יי מתאים גם לאירועים קטנים?`,
          a: `כן, השירות מותאם גם לאירועים מצומצמים וגם לאירועים גדולים, בהתאם לאופי האירוע ולמקום.`,
        },
        {
          q: `האם תקליטן {city} מספק גם ציוד תאורה?`,
          a: `ברוב המקומות קיימת תאורה בסיסית לרחבה. ניתן לשדרג לתאורת במה ועיצוב תאורה מתקדם בהתאמה אישית, בשיתוף ספקים מובילים ובהתאם לבחירה.`,
        },
        {
          q: `מה האטרקציות הפופולריות לאירועים {city}?`,
          a: `האטרקציות הפופולריות כוללות זיקוקים קרים, עשן כבד, בלונים מתפוצצים, בועות סבון, אותיות, תאורת לייזר, תאורת במה, נגנים חיים, קונפטי, שופרות, דרבוקות, צלם מגנטים, בר קוקטיילים ועוד.`,
        },
        {
          q: `האם ניתן לקיים אירוע בשטח פתוח או בלוקיישן מיוחד?`,
          a: `כן, ניתן לקיים אירועים בשטח פתוח, חוף, גן או לוקיישן מיוחד. אירועים מסוג זה דורשים התאמה של מערכות סאונד, תאורה וציוד נוסף בהתאם למקום ולתנאי השטח.`,
        },
        {
          q: `איך מתאימים מוזיקה לקהל מגוון באירוע?`,
          a: `התאמת מוזיקה לקהל מגוון נעשית באמצעות קריאת קהל בזמן אמת ושילוב נכון בין סגנונות, תקופות וקצבים שונים כדי ליצור חיבור בין האורחים ולשמור על רחבה פעילה.`,
        },
        {
          q: `האם יש אפשרות לבחירת פלייליסט מלא?`,
          a: `בוודאי. ניתן להעביר רשימת שירים מלאה, רשימת מועדפים, רשימת לא לשים או רק כיוונים כלליים. הפלייליסט משמש בסיס, ובאירוע עצמו המוזיקה מותאמת לרחבה ולקהל.`,
        },
        {
          q: `האם אפשר לשלב נגנים חיים או מופע לייב?`,
          a: `כן, ניתן לשלב נגנים חיים כמו סקסופון, כנרית, דרבוקות, בוזוקי ונגנים נוספים בהתאם לסגנון האירוע ולבחירה האישית.`,
        },
        {
          q: `כמה זמן מראש כדאי לשריין תקליטן?`,
          a: `מומלץ לשריין לפחות 3–6 חודשים מראש, ובתאריכים מבוקשים אף מוקדם יותר.`,
        },
        {
          q: `מה חשוב לבדוק בחוזה מול דיג׳יי?`,
          a: `כדאי לוודא מה כלול במחיר, שעות עבודה, אפשרות להארכה, תנאי ביטול, דרישות טכניות מהמקום והאם יש גיבוי לציוד.`,
        },
        {
          q: `האם יש גיבוי לציוד?`,
          a: `כן, תקליטן מקצועי מגיע עם ציוד חלופי ותכנית חירום למקרה הצורך.`,
        },
        {
          q: `האם אפשר לשלב וידאו או מצגת באירוע?`,
          a: `כן, ניתן לשלב מסכים להצגת קליפים, מצגות ותמונות אישיות במהלך האירוע וכן לשלב קטעי סאונד ווידאו כחלק מהשואו.`,
        },
      ],
      homeEvent: [
        {
          q: `מה כולל שירות תקליטן לאירוע?`,
          a: `השירות כולל היכרות אישית ובניית פסקול מותאם במיוחד עבורכם, ליווי מקצועי לאורך כל הדרך, קריאת קהל חדה, מיקסים מדוייקים ושילוב סגנונות, סאונד ואנרגיה שמבטיחה אירוע ושמחה מהרגע הראשון ועד השיר האחרון.`,
        },
        {
          q: `כמה עולה די ג׳יי לאירוע?`,
          a: `בדרך כלל טווח המחירים נע בין 2,000 ל־5,000 ₪, בהתאם לסוג האירוע, גודל האירוע, המיקום והתוספות שנבחרות.`,
        },
        {
          q: `לאילו סוגי אירועים אתה מתאים כדיג׳יי?`,
          a: `אני מתאים לחתונות, חינות, בר ובת מצווה, אירועי חברה, מסיבות עובדים, ימי גיבוש, מסיבות פרטיות ואירועים משפחתיים.`,
        },
        {
          q: `איך אתה מתאים מוזיקה לאירועים לקהל?`,
          a: `אני קורא את הרחבה בזמן אמת ומשלב בין סגנונות, תקופות וקצבים שונים בהתאם לאווירה ולקהל, כדי לשמור על רחבה פעילה לאורך כל האירוע.`,
        },
        {
          q: `האם יש לך ציוד דיג׳יי והגברה משלך?`,
          a: `כן. אני מגיע עם ציוד דיג׳יי מקצועי והגברה הכוללת רמקולים, מיקסר ומיקרופונים, בהתאם לצרכי המקום ולגודל האירוע.`,
        },
        {
          q: `האם אפשר לשלב גם תאורה באירוע?`,
          a: `ברוב המקומות קיימת תאורה בסיסית לרחבה. למי שמעוניין, ניתן לשדרג לתאורת במה ועיצוב תאורה מתקדם בהתאמה אישית ובשיתוף ספקים מובילים, בהתאם לבחירה.`,
        },
        {
          q: `כמה זמן מראש כדאי לסגור תקליטן?`,
          a: `מומלץ לשריין כמה חודשים מראש, ובתאריכים מבוקשים או בעונות עמוסות אפילו מוקדם יותר כדי להבטיח זמינות.`,
        },
        {
          q: `האם די ג׳יי מתאים גם לאירועים קטנים ואינטימיים?`,
          a: `בהחלט. אני מתאים את עוצמת הסאונד, סגנון המוזיקה והאווירה גם לאירועים קטנים כמו מסיבות בית, גג, ימי הולדת ואירועים משפחתיים מצומצמים.`,
        },
        {
          q: `איך בוחרים דיג׳יי לאירוע?`,
          a: `מומלץ לבדוק ניסיון, המלצות מאירועים אמיתיים, סרטונים, סגנון מוזיקלי שמתאים לכם וכמובן חיבור אישי בשיחה או פגישה.`,
        },
        {
          q: `מה כוללות החבילות והאפשרויות לשדרוג?`,
          a: `חבילת הבסיס כוללת הגעה עם ציוד הדיג׳יי והנגינה לאורך האירוע. ניתן לשדרג בהתאמה אישית עם עמדות דיג׳יי מעוצבות, אפטר פארטי, אטרקציות שונות, נגנים חיים ותוספות נוספות לפי הבחירה.`,
        },
        {
          q: `מה האטרקציות הפופולריות באירועים?`,
          a: `האטרקציות הפופולריות כוללות זיקוקים קרים, עשן כבד, בלונים מתפוצצים, בועות סבון, אותיות, תאורת לייזר, תאורת במה, נגנים חיים, קונפטי, שופרות, דרבוקות, צלם מגנטים, בר קוקטיילים ועוד.`,
        },
        {
          q: `האם יש גיבוי לציוד במקרה של תקלה?`,
          a: `כן. תקליטן מקצועי מגיע עם ציוד חלופי ותכנית חירום למקרה הצורך.`,
        },
        {
          q: `האם אתה מנגן גם באירועי חברה וימי גיבוש?`,
          a: `כן, אני מנגן באירועי חברה, השקות, מסיבות עובדים וימי גיבוש ומתאים את המוזיקה לאופי הארגון והקהל.`,
        },
        {
          q: `איך בונים פלייליסט לאירוע?`,
          a: `בונים יחד כיוונים מוזיקליים, רשימת שירים חשובים ורשימת שירים שפחות מתאימים – ומשם אני בונה סט דינמי שמתאים לזרימה של הערב.`,
        },
        {
          q: `האם אפשר לשלוח רשימת שירים מראש?`,
          a: `בוודאי. ניתן לשלוח רשימת שירים אהובים, שירים שחייבים להתנגן ושירים שפחות מתאימים – ואני משלב אותם בצורה חכמה לאורך האירוע.`,
        },
        {
          q: `מה קורה אם האירוע מתארך?`,
          a: `אפשר להאריך את זמן הנגינה מעבר למה שסוכם מראש, בתיאום במקום ובתוספת תשלום לפי שעה.`,
        },
        {
          q: `האם מתקיים תיאום לפני האירוע?`,
          a: `כן, מומלץ לקיים שיחה או פגישה לפני האירוע כדי לעבור על לוח הזמנים, סגנונות המוזיקה, רגעי השיא ושירים חשובים עבורכם.`,
        },
      ],
    },
  },

// בתוך he
  // ─────────────────────────────────────────────────────────────
  // GEO — Regions & Cities (UI labels only)
  // ─────────────────────────────────────────────────────────────
  geo: {
    regions: {
      דרום: 'דרום',
      מרכז: 'מרכז',
      צפון: 'צפון',
    },

    cities: {
      'באר שבע': 'באר שבע',
      'אשקלון': 'אשקלון',
      'אשדוד': 'אשדוד',
      'קריית גת': 'קריית גת',
      'אופקים': 'אופקים',
      'נתיבות': 'נתיבות',
      'שדרות': 'שדרות',
      'להבים': 'להבים',
      'עומר': 'עומר',
      'דימונה': 'דימונה',
      'קריית מלאכי': 'קריית מלאכי',
      'ערד': 'ערד',
      'ירוחם': 'ירוחם',
      'מיתר': 'מיתר',
      'אילת': 'אילת',
      'קריית עקרון': 'קריית עקרון',
      'גן יבנה': 'גן יבנה',

      'תל אביב': 'תל אביב',
      'רמת גן': 'רמת גן',
      'גבעתיים': 'גבעתיים',
      'רמת השרון': 'רמת השרון',
      'אור יהודה': 'אור יהודה',
      'ראשון לציון': 'ראשון לציון',
      'חולון': 'חולון',
      'בת ים': 'בת ים',
      'רעננה': 'רעננה',
      'הרצליה': 'הרצליה',
      'פתח תקווה': 'פתח תקווה',
      'יבנה': 'יבנה',
      'רחובות': 'רחובות',
      'גדרה': 'גדרה',
      'נס ציונה': 'נס ציונה',
      'כפר סבא': 'כפר סבא',
      'הוד השרון': 'הוד השרון',
      'מודיעין': 'מודיעין',
      'ירושלים': 'ירושלים',
      'בית שמש': 'בית שמש',
      'מעלה אדומים': 'מעלה אדומים',
      'רמלה': 'רמלה',
      'ראש העין': 'ראש העין',
      'נתניה': 'נתניה',
      'חדרה': 'חדרה',
      'עמק חפר': 'עמק חפר',
      'חיפה': 'חיפה',
      'קריות': 'קריות',
      'יקנעם': 'יקנעם',
      'עפולה': 'עפולה',
      'עמק יזרעאל': 'עמק יזרעאל',
      'נוף הגליל': 'נוף הגליל',
      'עכו': 'עכו',
      'נהריה': 'נהריה',
      'כרמיאל': 'כרמיאל',
      'טבריה': 'טבריה',
      'קיסריה': 'קיסריה',
      'זכרון יעקב': 'זכרון יעקב',
    },

    venuesByCity: {
      'באר שבע': [
        'אודיסאה',
        'אגמים',
        'נרניה',
        'סופיה',
        'גני בראשית',
        'אורייתא',
        'נחלה בעתיקה',
        'בארוק',
        'אורימא',
        'אולמי אופל',
        'אולמי פפה מישל',
        'מרסל וניו',
        'ארמון זהרה',
        'תבל',
        'חצר בוצ׳רי',
        'Pulse',
        'הבוסתן',
        'ROY',
        'אולמי ארי',
      ],
      'אשקלון': [
        'Noale',
        'הרמוניה בגן',
        'OPA',
        'מידאה',
        'דולוס',
        'טליה',
        'קצת אחרת',
        'מקום בים',
        'סילבר',
        'שרי',
        'גני הצבי',
        'אולמי הברון וגני הברון',
        'אחוזת המלך שלמה',
        'גני שמשון',
        'לשם',
        'אולמי לשם',
        'סי איוונט',
        'דוריה',
        'איווה',
      ],
      'אשדוד': [
        'הרמוניה בגן',
        'טאו',
        'קלואה',
        'גאלרי 35',
        'אהובת הספן',
        'טרויה',
        'אדמה',
        'טירה',
        'ממילא',
        'נועה',
        'בלו קאסל',
        'דימסיה',
        'פרדייז',
        'אילבן',
        'Benjamin',
        'אקסיטו',
        'אופרה',
        'DIWAN',
        'הילה',
        'סהרה',
        'היקב',
      ],
      'קריית גת': [
        'גני האחוזה',
        'שוהם',
        'אפיריון',
        'מאמא',
        'AZAR',
        'גולדן לופט',
      ],
      'אופקים': [
        'אליבא',
        'פאלאסיו',
        'ארמונות נאמן',
        'הדרת תורה',
        'רחלה',
      ],
      'נתיבות': [
        'אחוזת דניאל',
        'לוריא',
        'ברכת שמים',
        'פה פה',
        'גן הפקאן',
        'מַלְכָּה',
        'דנדו',
        'דעני לחנניה',
        'אולה',
      ],
      'שדרות': [
      ],
      'להבים': [],
      'עומר': [
        'JOYA',
      ],
      'דימונה': [
        'גני דניאל',
        'אדורה',
        'אולמי דניאל',
        'פלמינגו',
        'Aria',
        'Emma',
      ],
      'קריית מלאכי': [
        'אהבתיה',
        'לחיים',
        'קברנה',
      ],
      'ערד': [],
      'ירוחם': [
        'היכל דוד',
      ],
      'מיתר': [],
      'אילת': [
      ],
      'קריית עקרון': [
        'שאטו',
        'רגעים',
        'אלגריה',
        'שונס',
        'ויגו',
        'סברס',
        'גלוריה',
        'נויה',
      ],
      'גן יבנה': [
        'לארה אירועים',
        'מטעמי שרה',
      ],

      'תל אביב': [
        'ריי',
        'הייאנד',
        'House No.Seven',
        'East',
        'טראסק',
        'מנדרין לופט',
        'גג העיר',
        'אביגדור',
        'בית השמחות',
        'גלריה דובנוב',
        'הלורנס',
        'שרביה',
        'ארקה',
        'רוקח',
        'חדר פרטי',
        'אקוסטה',
        'בית על הים',
        'יורדי הסירה',
        'רפאל',
        'ריברסייד',
      ],
      'רמת גן': [
        'דימול פלטיניום',
        'מנהטן אירועים',
      ],
      'גבעתיים': [
      ],
      'רמת השרון': [
        'פסק זמן',
        'צהלה',
        'גומא',
        'טזורו',
        'מולדת',
        'סטוקו',
        'אוורסט',
        'פלורה',
      ],
      'אור יהודה': [
        'ארי',
        'שלוש 3',
        'סיטי סטאר',
        'ELYA',
        'סלינה',
        'אולמי קינגסטון',
        'חאן הדקל',
        'אוריאנה',
        'EXCITE',
        'אור בלב',
        'סלנה',
        'פארדייס בכפר',
        'לה סינקו',
        'סטאר',
      ],
      'ראשון לציון': [
        'אדל',
        'TAI',
        'גרייס',
        'פראיסו',
        'ארשלם',
        'תרין',
        'RAIN',
        'לאו',
        'אחוזת ים',
        'לאגו',
        'אמיליה',
        'פלטין',
        'SAY',
        'אילבן גרדן',
        'מון',
        'דואאה',
        'קליספרה',
        'סיה',
        'סייטה',
        'ספארק',
      ],
      'חולון': [
        'קויה',
        'ואסקו',
        'סליה',
      ],
      'בת ים': [
        'דריה',
        'סאנסט הול',
        'סי ים',
        'סוסייטי',
        "בלאג'יו",
      ],
      'רעננה': [
        'בית',
        'בדולינה',
        'שנקין',
        'לואי',
        'ME',
      ],
      'הרצליה': [
        'אמדו',
        'דופלקס',
        'ניין',
        'גלואו',
        'תיאודור',
        'B56',
        'אימג׳ן',
        'אלור',
        'ג׳ייקובס',
        'מערבה',
      ],
      'פתח תקווה': [
        'Nest Roof',
        '58',
        'ואמוס',
        'אמורה',
        'ג׳ונם',
        'טרמינל',
        'פוראבר',
        'ונישן',
        'דרזנר',
        'מייפל',
        'קסאנאדו',
        'סנטרל',
        'טוסקה',
        'קליי',
        'ריספקט קלאב',
        'אפטאון',
        'Riya',
        'לה פלומה',
        'הבית האורבני',
        'דרך הטבע',
      ],
      'יבנה': [
        'עדיה',
        'טווינס',
        'וסיליו',
        'הרמוניה בגן',
        'ארטורוס',
        'אולם שמחות',
        'אורו',
      ],
      'רחובות': [
        'קולוניה',
        'רוז',
        'לורן',
        'שאטו',
        'הפרדס',
        'ויגו',
        'הגבעה',
        'אלגריה',
        'חוות אלנבי',
        'לוק',
        'ויה',
        'סינקו',
        'שונס',
        'סיה',
        'רגעים',
        'אמארה',
        'יהודה',
        'הרמוניה בגן',
        'ירוק על המים',
      ],
      'גדרה': [
        '1884 חצר הבילויים',
        'שנהב',
        'NOÉ',
        'טרוסא',
        'הרמוניה בגן',
        'חצר המלכה',
        'אגדתא',
        'אדאו',
        'נסיה',
        'לילות קסומים',
        'ג׳קובס לופט',
      ],
      'נס ציונה': [
        'גאיה',
        'הפרדס',
        'אמארה',
        'סיה',
        'אלה',
        'ויה',
        'גבריאל',
        'ויטראז׳',
        'NOAM',
        'באסיקו',
        'קולוניה',
        'חוות אלנבי',
        'בית הדבש',
        'Faberge',
        'האחוזה',
        'רוז',
        'הנחלה',
        'לורן',
        'הגבעה',
        'תרין',
        'חצר נצר',
      ],
      'כפר סבא': [
        'White',
        'וואלי',
        'צל החורש',
        'נועל׳ה',
        'fabrika',
        'אולמי שרון',
        'עדן',
        'שירת הפארק',
        'מועדון בליס',
        'שנקין',
        'סיטרוס',
        'גן הפקאן',
        'היישה',
        'ME',
        'בית',
        'לואי',
        'צ׳וייס',
        'החצר האחורית',
        'Wish Loft',
      ],
      'הוד השרון': [
        'החצר האחורית',
        'אחוזת השרון',
        'B4',
        'ווילג׳',
        'גומא',
      ],
      'מודיעין': [
        'הרמוזו',
        'האחוזה',
        'השדרה',
        'לואר',
        'Quality Events',
        'הבריאה',
        'בית השף',
        'המוביט',
        'גולן הפקות',
        'אהבת שלום',
        'נוף עילית',
        'היכל הנגינה',
        'מיתרים',
        'עינן',
        'גן הדסים',
        'ויקטוריה',
        'וולקאן',
        'אוסליבן',
        'נאות שמחה',
        'אריא',
      ],
      'ירושלים': [
        'האגם',
        'וולקאן',
        'הדריה',
        'אולמי נוף ירושלים',
        'יער עין חמד',
        'אולמי אלגרו',
        'לה בל',
        'אולמי בית ישראל',
        'ארטמיסיה',
        'בראשית',
        'קדמא',
        'סופיה',
        'אולמי שרון',
        'דסטינו',
        'ארויה',
        'סקויה',
        'אולמי פביליון',
        'הרמוני',
        'בוטיק בטחנה',
        'קינגסטון',
        'בית שמואל',
        'עולמיא',
        'אורכדיה',
        'סיטי הול',
        'דיויד קסטל',
        'אולמי חי',
        'אמיל בוטה',
        'אולמי בעלזא',
        'שמחה בכותל',
        'מרקש',
        'Modular',
        'קדמא מידטאון',
        'אמרלד',
        'אולמי היכל דוד',
        'תמרה',
        'The Pavilion',
        'טרקליני מונדיאל',
        'דה בוקס',
        'חוות דרך ארץ',
      ],
      'בית שמש': [
        'סרה',
        'אמרלד',
        'לורנסה',
        'VINE',
        'הכרמים',
        'נריה',
        'אולמי ויולה',
        'אילת שרה',
        'כינור דוד',
        'חוות דרך ארץ',
        'אוהל פייגא',
        'אולמי פאהרנד',
        'שעלים דרור',
      ],
      'מעלה אדומים': [
        'גאמוס',
        'סוליס',
        'מדבר',
        'מגיק',
        'שרי לופט',
        'החצר',
        'יו-יו',
      ],
      'רמלה': [
        'אמדאוס',
        'אולמי אצילה',
        'אחוזת אשר',
        'אולמי אמביינטה',
        'אולמי לאונרדו',
        'אולמי אליסון',
        'אולמי הוד פלוס',
        'קליפסו אירועים',
        'ירוק על המים',
        'אולמי לאפייט',
        'קליפסו שמחות',
      ],
      'ראש העין': [
        'אוורסט',
        'ריי',
      ],
      'נתניה': [
        'THE ONE',
        'סולאנה',
        '5.91',
        'ג׳ונה',
        'אקפלה',
        'The Garden',
        'פיטנגו',
        'פולגה',
        'שירת הים',
        'סילבר',
        'שיבולים',
        'לואי',
        'You',
        'שרונית',
        'תל-יה',
        'אלכסנדר',
        'עלמה',
        'האחוזה',
        'הכרם',
        'הלל',
      ],
      'חדרה': [
        'יארה',
        'גאיה',
        'ערוגות בושם',
        'אמה',
        'אקו',
        'ארטיסטה',
        'דונה',
        'ויה קסליו',
        'לימאי',
        'ביער',
        'קוליוונט',
        'מרלו',
        'מולה',
        'אלכסנדר',
        'הודיה',
        'אימגו',
        'חלום בחווה',
        'על הנחל',
        'אודאון',
        'עדן',
      ],
      'עמק חפר': [
        'ויה קסליו',
        'קדיתא',
        'אלכסנדר',
        'אודאון',
        'סיירוס',
        'לוקא',
        'קאי',
        'WIN',
        'שרונית',
        'העמק',
        'ערוגות בושם',
        'ארטיסטה',
        'תל-יה',
        'אמה',
        'יארה',
        'חופית',
        'הגלריה',
        'גאיה',
        'קוליוונט',
        '88',
      ],

      'חיפה': [
        'גלריה 279',
        'ימה',
        'קאלה',
        'אדם וחווה',
        'לבן',
        'Ciel',
        'אלמה',
        'דה ביץ׳',
        'הינומה',
        'בלה צ׳ופ',
        'בקתה ביער',
        'יסמין',
        'טרומפטה',
        'פלייגראונד',
        'הילולה',
        'פקטורי',
        'גארדן הוטל',
        'אלמוג',
        'האחוזה',
      ],
      'קריות': [
      ],
      'יקנעם': [
        'Sky Garden',
        'מקסימו',
      ],
      'עפולה': [
        'אצולת העמק',
        'סטורי Story',
        'אולמי פאר',
        'אולמי פאר בראשית',
        'Haosher',
        'אולמי האושר',
        'W גריל בר',
      ],
      'עמק יזרעאל': [
        'כחול וירוק',
        'הסיינדה',
        'בת הגלבוע',
        'Wide Open',
        'אחוזת דוד',
        'סגרא',
        'אצולת העמק',
        'הגלריה',
        'סטורי',
        'פאר בראשית',
        'ללוס',
        'Sky Garden',
        'W גריל בר',
        'Seven Hills',
        'אולם המופעים יפעת',
        'מרפסת',
        'RED',
        'לה רנסנס',
        'כרמלה',
        'שמורתה',
      ],
      'נוף הגליל': [
        'לה רנסנס',
        'ניו גרנד פאלאס',
        'סגנון',
        'אבו מאהר',
        'פרידמן',
        'תעאלילכום',
        'אמפי פארק נוף הגליל',
        'כחול וירוק',
        'קיבוץ משעול',
        'נופארק',
        'Fair Ball',
        'גני האדי באלק',
        'השביל לגבעה',
        'השכונתית',
        'שאטו דה וולה',
        'בת הגלבוע',
      ],
      'עכו': [
        'טופז על הים',
        'אלמאס',
        'מרום',
        'ארד',
        'יהלום',
        'אולמות האבירים',
        'I-DO',
        'גלורי',
        'בית היסמין',
        'אודיטוריום עכו',
        'רותס',
        'אודיטוריום אידית וולפסון',
        'אחוזת סנדרין',
        'שמורתה',
      ],
      'נהריה': [
        'אופרה',
        'אחוזת סנדרין',
        'בחצר',
        'NOVO',
        'גארדן',
        'שמורתה',
        'איפראן',
      ],
      'כרמיאל': [
        'Ramma',
        'שביט',
      ],
      'טבריה': [
        'גני איילון',
        'קמביו',
        'מאגיה',
        'ארמוניה',
        'גן באגם',
        'היגאה',
        'אולמי חן',
        'חוף התכלת',
        'Venecia',
        'הסיינדה',
      ],
      'קיסריה': [
        'טרה',
        'יקבי קיסריה',
        'קיסר ים',
        'וילה נונה',
        'יונו',
        'כוכב הים',
        'אירועים במתחם',
        'על הים',
      ],
      'זכרון יעקב': [
        'בית המוכתר',
        'הקיוב',
        'מטעים',
      ],
    },

    globalLabel: 'כל הארץ',
  },

} as const;

export type HePack = typeof he;
